<template>
  <div style="height: 100%; position: relative;">
    <div class="ijd-reminder" v-if="showTips !== showVal">
      <iconpark-icon name="Group" :size="16" style="vertical-align: middle;"></iconpark-icon>
      <el-carousel height="40px" direction="vertical" style="width: 100%;" :interval="5000" indicator-position="none">
        <el-carousel-item v-for="(item, index) in notice" :key="index">
          <span class="reminder-text" :title="item.text"> 公告：{{ item.text }}</span>
          <span @click="showNoticeTip(index)" class="close-reminder">
            <iconpark-icon name="circle-x" :size="14" style="vertical-align: middle;"></iconpark-icon>
          </span>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div class="ijd-reminder" v-if="showTips !== showVal"><iconpark-icon name="Group" :size="16" style="vertical-align: middle;"></iconpark-icon>
         <span style="margin-left: 0.375rem;vertical-align: middle;"> 公告：爱校对上线重点词功能，请在左侧“我的词库”添加；“下载中心”安装插件提升校对效率，更多信息请关注“爱校对”公众号。</span>
         <span @click="showNoticeTip(showVal)" class="close-reminder">
          <iconpark-icon name="guanbi" :size="18" style="vertical-align: middle;"></iconpark-icon>
         </span>
      </div> -->
    <div class="display-miss">
      <ul v-if="adviceFirst.length">
        <li v-if="adviceFirst[2].slice(0, 1) == 4" @click="handleWrongly('delete', id, 0)">
          建议删除<span class="del-miss">删除</span>
        </li>
        <li v-else-if="adviceFirst[2].slice(0, 1) == 7" style="cursor: no-drop">
          建议调整语序
        </li>
        <li v-else-if="adviceFirst[2].slice(0, 1) == 3" style="cursor: no-drop">
          建议补充字词
        </li>
        <li v-else-if="adviceFirst[2].slice(0, 1) == 8 && !adviceFirst[0]" style="cursor: no-drop">
          敏感词汇
        </li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[2] == '10-1'" style="cursor: no-drop">中英类型错用</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[2] == '10-2'" style="cursor: no-drop">成对标点</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[2] == '10-3'" style="cursor: no-drop">点号连用</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[2] == '9-1'" style="cursor: no-drop">建议检测此处地址</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[2] == '9-2'" style="cursor: no-drop">建议检查此处日期</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[2] == '11-1'" style="cursor: no-drop">建议检查此处重点词</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[1] == 4" style="cursor: no-drop">自定义敏感词</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[1] == 5" style="cursor: no-drop">自定义错词</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[1] == 6" style="cursor: no-drop">共享词库敏感词</li>
        <li v-else-if="!adviceFirst[0]&&adviceFirst[1] == 7" style="cursor: no-drop">共享词库错词</li>
        <li v-else-if="adviceFirst[0]" @click="handleWrongly('edit', id, 0)">
          建议修改为&nbsp;<span class="edit-miss"><strong>{{ adviceFirst[0] }}</strong></span>
        </li>
        <li v-else style="cursor: no-drop">
          未知的分类
        </li>
        <li @click="handleWrongly('ignore', id, 0)"><span>忽略</span></li>
        <!-- <li @click="handMiss(1, 0, 'ignoreAllMiss')" v-if="some > 1">
            忽略相同{{ some }}处
          </li> -->
      </ul>
    </div>
    <div class="container">
      <div class="quill-container" :style="showTips == showVal ?'margin-top: 2.75rem; height: calc(100% - 5.5rem);':'margin-top: 4.5rem; height: calc(100% - 7.25rem)'">
        <div class="toolbar-control">
          <span class="toolbar-menu">
            <el-dropdown trigger="click" class="line-height-control">
              <button class="el-dropdown-link" style="cursor: pointer;" @click.stop="() => {return}">
                <iconpark-icon name="hangjianju" style="vertical-align: middle;margin-right: 0.25rem;" :size="16"></iconpark-icon>
                <span class="all-middle"> {{ lineConfig.text }}</span>
                <iconpark-icon class="dropdown-icon all-middle" name="lujing91" style="margin-left: 0.125rem;" :size="12"></iconpark-icon>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item,index in lineConfig.list" :key="index" @click.native="lineControl(item.value)">{{ item.text }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span class="toolbar-menu">
            <el-dropdown trigger="click" @command="addWords($event)" class="line-height-control" :disabled="dropDisabled">
              <button class="el-dropdown-link" @click.stop="() => {return}">
                <iconpark-icon name="cidian" style="vertical-align: middle; margin-right: 0.25rem;" :size="16"></iconpark-icon>
                <span class="all-middle">加入词库</span>
                <iconpark-icon class="dropdown-icon all-middle" name="lujing91" style="margin-left: 0.125rem;" :size="12"></iconpark-icon>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="4"
                                  v-show="$store.state.myRole != 'user' && $store.state.myRole != 'free' && $store.state.myRole != 'user_admin'">正词（团队词库）</el-dropdown-item>
                <el-dropdown-item :command="5"
                                  v-show="$store.state.myRole != 'user' && $store.state.myRole != 'free' && $store.state.myRole != 'user_admin'">错词（团队词库）</el-dropdown-item>
                <el-dropdown-item :command="6"
                                  v-show="$store.state.myRole != 'user' && $store.state.myRole != 'free' && $store.state.myRole != 'user_admin'">敏感词（团队词库）</el-dropdown-item>
                <el-dropdown-item :command="1">正词（个人词库）</el-dropdown-item>
                <el-dropdown-item :command="2">错词（个人词库）</el-dropdown-item>
                <el-dropdown-item :command="3">敏感词（个人词库）</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span class="toolbar-menu line-height-control" @click="clearText">
            <iconpark-icon name="shanchu" style="vertical-align: middle; margin-right: 0.25rem;" :size="16"></iconpark-icon>
            <span class="all-middle">清空</span>
          </span>
          <span class="toolbar-menu line-height-control" @click="copyText">
            <iconpark-icon name="fuzhi" style="vertical-align: middle; margin-right: 0.25rem;" :size="16"></iconpark-icon>
            <span class="all-middle">复制全文</span>
          </span>
          <span class="text-length" style="color: rgba(230, 71, 89, 1); cursor: pointer;" v-popover:textLength v-show="getTextLengthVisible(1).visible">
            <span class="all-middle">共{{ textLength }}字</span>
            <iconpark-icon name="Group324" class="all-middle" style="margin-left: 0.125rem;" :size="16"></iconpark-icon>
            <el-popover ref="textLength" placement="bottom" title="" popper-class="ijd-el-popover" width="180" trigger="click">
              <div style="margin: 0rem 0.5rem">
                {{getTextLengthVisible(1).text}}
              </div>
            </el-popover>
          </span>
          <span class="text-length" v-show="getTextLengthVisible(2).visible">共{{ textLength }}字</span>
        </div>
        <div class="editor-control">
          <quill-editor v-model="content" @change="changeText($event)" ref="myQuillEditor" :options="editorOption"></quill-editor>
          <div class="highlight">
            <div v-for="(item, index) in highlight" class="ijd-high-light" :style="{
                              left: item.left + 'px',
                              top: item.top + 'px',
                              width: item.width + 'px',
                              height: item.height + 'px',
                          }" v-show="item.show" :id="item.id" :key="index"></div>
            <div class="ijd-high-light" style="position: absolute;" ref="ijdHighRef">
            </div>
          </div>
        </div>

      </div>
      <div class="tip-container" :style="showTips == showVal?'margin-top: 2.75rem; height: calc(100% - 5.5rem);':'margin-top: 4.5rem; height: calc(100% - 7.25rem)'">
        <div class="tip-container-button">
          <div>
            <ijd-button :left="'0px'" width="40%" :loading="checkConfig.loading" :method="checkConfig.method" :buttonText="checkConfig.buttonText"
                        :disabled="checkConfig.disabled" @checkText="checkText"></ijd-button>
            <span class="change-check-mode">
              <span class="mode-icon">
                <iconpark-icon name="Group331" :size="20" v-show="checkMode == 2"></iconpark-icon>
                <iconpark-icon name="Group332" :size="20" v-show="checkMode == 3"></iconpark-icon>
              </span>
              <el-tooltip class="item" effect="light" :open-delay="1500" placement="bottom">
                <div slot="content">查准：显著降低误报概率，准确度更高
                  <br />查全：开放更低概率错误，提示数更多<br /><br />切换后将会在点击下一次校对时生效
                </div>
                <span class="mode-opertor" @click="changeCheckMode">切换模式</span>
              </el-tooltip>
            </span>
            <span class="change-check-mode">
              <span class="mode-icon" style="display: inline-block; height: 1.25rem; padding-top: 1.0.3125rem;">
                <iconpark-icon name="bookopen" :size="18"></iconpark-icon>
              </span>
              <span class="mode-opertor" @click="showPackge">行业词库</span>
            </span>
            <!-- <ijdButton class="no_border" :width="`20%`" :type="'revoke1'" :buttonText="packgeText" method="showPackge" @showPackge="showPackge" :padding="'0px'"></ijdButton> -->
            <ijdButton class="no_border" :width="`14%`" :type="'revoke2'" :buttonText="revokeText" method="undoEdit" @undoEdit="undoEdit" :disabled="undoInfo"
                       :padding="'0px'"></ijdButton>
          </div>
          <div class="tip-container-button-tag">
            <ijd-tag :margin="'8px 0'" :color="filterParams.all" @filterResult="filterResult(0)">所有提示 {{ computedTipsNumber(0) }}</ijd-tag>
            <ijd-tag type="ijd-tag-high" :color="filterParams.high" @filterResult="filterResult(1)">高概率 {{ computedTipsNumber(1) }}</ijd-tag>
            <ijd-tag type="ijd-tag-low" :color="filterParams.low" @filterResult="filterResult(2)">低概率 {{ computedTipsNumber(2) }}</ijd-tag>
          </div>
          <div class="tip-container-button-tag2">
            <ijd-tag :margin="'8px 0'" type="ijd-tag-custom" :color="filterParams.custom" @filterResult="filterResult(5)">自定义
              {{ computedTipsNumber(5) }}</ijd-tag>
            <ijd-tag :color="filterParams.sensitive" type="ijd-tag-sensitive" @filterResult="filterResult(3)">敏感词 {{ computedTipsNumber(3) }}</ijd-tag>
            <ijd-tag type="ijd-tag-symbol" :color="filterParams.symbol" @filterResult="filterResult(4)">标点 {{ computedTipsNumber(4) }}</ijd-tag>
            <!-- <span style="width: 7rem;"></span> -->
          </div>
        </div>
        <div class="tip-container-show">
          <div class="respeat-tip" v-if="respeatArr.length > 0">
            <div>
              <div class="respeat-tip-title" @click="changeShowRespeat">
                <span class="all-middle">高频提示汇总({{ respeatArr.length }}个)</span>
                <iconpark-icon ref="respeatIconRef" style="transition: all ease .3s; margin-left: 0.125rem;" class="all-middle" name="Group186"></iconpark-icon>
              </div>
              <el-collapse-transition>
                <div class="respeat-tip-list" v-show="showRespeat">
                  <div class="respeat-tip-list-item" v-for="(item, index) in respeatArr" :key="index" @click="spandCard(item.someIndex[0], 0, 'high')">
                    <el-row style="line-height: 1.375rem;position: relative; width: 100%;">
                      <el-col :span="13" style="white-space: nowrap;">
                        <span class="respeat-number">{{ item.some }}</span>
                        <span class="all-middle tip-word">{{ miss[item.someIndex[0]] }}</span>
                        <span class="all-middle word-class" v-if="adviceType(item.advice)">{{ adviceType(item.advice) }}</span>
                        <!-- <span class="all-middle word-class" v-if="adviceType(item1)">{{ adviceType(item1) }}</span> -->
                        <iconpark-icon name="lujing8" :size="10" style="margin: 0 0.5rem; vertical-align: middle;" v-else-if="item.advice[0]"></iconpark-icon>
                        <span class="edit-word" v-if="item.advice[0]">{{ item.advice[0] }}</span>
                      </el-col>
                      <el-col :span="11">
                        <span class="respeat-opertor" @click="batchWrongly(item, 1)">全部应用</span>
                        <span class="respeat-opertor" style="margin-left: 1.5rem;" @click.stop="batchWrongly(item, 2)">全部忽略</span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
          </div>
          <div class="empty-tip" v-if="computedTipsNumber(0) == 0 && filterParams.all == ''">
            <iconpark-icon name="Illustrations-900nlfg6" :size="177"></iconpark-icon>
            <div class="tip-text">恭喜没有错误</div>
          </div>
          <div class="empty-tip" v-else-if="filterParams.all != '' && filterNum == 0">
            <iconpark-icon name="Illustrations" :size="177"></iconpark-icon>
            <div class="tip-text">该筛选分类下没有提示</div>
          </div>
          <transition-group appear tag="div" name="list">
            <div class="check-tips" v-for="(item,index) in advice" :key="item[0].slice(-1)[0].id == undefined ? item[0].slice(-1)[0] : item[0].slice(-1)[0].id"
                 :style="marginStyle(item, index)">
              <div class="check-tip" v-for="item1,index1 in item" :key="index1" :ref="`checkTip${index}`" :style="boderStyle(item1, index, item)"
                   @click="spandCard(index, index1)" @mouseenter="missCard(index, item)" @mouseleave="missCardLeave(index, item)"
                   v-show="filterParamsComputer(item1)">
                <div class="tip-info">
                  <span v-if="item1[1] == 6 || item1[1] == 7 || item1[1] == 10"
                        style="position: absolute; left: 0.625rem; top: 0.5rem;color: rgba(19, 205, 82, 0.5);"><iconpark-icon
                                   name="Vector-900n8p36"></iconpark-icon></span>
                  <el-row class="tip-info-content" style="line-height: 1.375rem;position: relative;">
                    <el-col :span="13" style="white-space: nowrap;">
                      <span class="all-middle tip-word">{{miss[index]}}</span>
                      <span class="all-middle word-class" v-if="adviceType(item1)">{{ adviceType(item1) }}</span>
                      <iconpark-icon name="lujing8" :size="10" style="margin: 0 0.5rem; vertical-align: middle;" v-else-if="item1[0]"></iconpark-icon>
                      <span class="all-middle result-word" :title="item1[0]" @mouseenter="missCard(index, item,index1)"
                            @mouseleave="missCardLeave(index, item1, index1)" v-if="handleResultWord(item1).value && handleResultWord(item1).display == false"
                            @click.stop="handleWrongly('edit', index, index1)">{{handleResultWord(item1).value}}</span>
                      <span class="symbol-word" v-else-if="handleResultWord(item1).value && handleResultWord(item1).display == true">
                        <span class="all-middle symbol-word-item" @mouseenter="missCard(index, item,index1)" @mouseleave="missCardLeave(index, item1, index1)"
                              @click.stop="handleWrongly('edit', index, index1, handleResultWord(item1).value[0])">{{handleResultWord(item1).value[0]}}</span>
                        <span class="all-middle symbol-word-attribute">或使用</span>
                        <span class="all-middle symbol-word-item" @mouseenter="missCard(index, item,index1)" @mouseleave="missCardLeave(index, item1, index1)"
                              @click.stop="handleWrongly('edit', index, index1, handleResultWord(item1).value[1])">{{handleResultWord(item1).value[1]}}</span>
                      </span>
                      <span class="all-middle result-word" style="margin-left: 0.5rem;" title="保留第一个标点" @mouseenter="missCard(index, item,index1)"
                            @mouseleave="missCardLeave(index, item, index1)" v-else-if="item1[2] =='10-3'"
                            @click.stop="handleWrongly('edit', index, index1, miss[index].slice(0,1))">保留一个标点</span>
                      <span class="all-middle delete-word" v-else-if="item1[2] == '4-1' || item1[2] == '4-'"
                            @click.stop="handleWrongly('delete', index, index1)">删除</span>
                    </el-col>
                    <el-col :span="11" style="text-align: right;">
                      <span class="handle-word" :ref="`handleWordRef` + index" v-if="index1 == 0">
                        <el-dropdown trigger="click" class="add-to-word" @command="addWord($event, index, index1, 'addWord', miss[index])"
                                     v-if="teamDicType(index)">
                          <button class="el-dropdown-link" style="cursor: pointer;font-size: 0.875rem;" @click.stop="() => {return}">
                            <span class="all-middle">加入词库</span>
                            <iconpark-icon class="dropdown-icon all-middle" style="margin-left: 0.25rem;" :size="12" name="lujing91"></iconpark-icon>
                          </button>
                          <el-dropdown-menu slot="dropdown" @mouseenter.native="missCard(index, item)" @mouseleave.native="missCardLeave(index, item)">
                            <el-dropdown-item :command="1">加入个人词库</el-dropdown-item>
                            <el-dropdown-item :command="2" v-show="teamDicType(index)">加入团队词库</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                        <span class="ignore-the-word all-middle" @click.stop="addWord(1, index, index1, 'addWord', miss[index])"
                              v-else-if="miss[index].length > 1">加入词库</span>
                        <el-dropdown trigger="click" class="ignore-the-word" @command="handleIgnore($event, index, index1)" v-show="computeThisSome(index) > 1">
                          <button class="el-dropdown-link" style="cursor: pointer;font-size: 0.875rem;" @click.stop="() => {return}">
                            <span class="all-middle">忽略</span>
                            <iconpark-icon name="lujing91" style="vertical-align: middle;margin-left: 0.25rem;" :size="12"></iconpark-icon>
                          </button>
                          <el-dropdown-menu slot="dropdown" @mouseenter.native="missCard(index, item)" @mouseleave.native="missCardLeave(index, item)">
                            <el-dropdown-item :command="1">忽略该处建议</el-dropdown-item>
                            <el-dropdown-item :command="2" v-show="computeThisSome(index) > 1">忽略相同{{ computeThisSome(index) }}处建议</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                        <span class="ignore-the-word all-middle" @click.stop="handleWrongly('ignore', index, index1)"
                              v-show="computeThisSome(index) == 1">忽略</span>
                      </span>
                    </el-col>
                  </el-row>
                  <div class="tip-detail">
                    <span v-if="item1[1] == 4"><strong>[自定义敏感词]&nbsp;</strong></span>
                    <span v-if="item1[1] == 5"><strong>[自定义错词]&nbsp;</strong></span>
                    <span v-if="item1[1] == 6"><strong>[共享词库敏感词]&nbsp;</strong></span>
                    <span v-if="item1[1] == 7"><strong>[共享词库错词]&nbsp;</strong></span>
                    <span v-if="(item1[2] == '1-1') || (item1[2]=='1-')">同音错误，建议替换</span>
                    <span v-else-if="item1[2].slice(0, 1) == 2">常见谐音错误，建议替换</span>
                    <span v-else-if="item1[2] == '5-3'">形近字错误，建议修改</span>
                    <span v-else-if="item1[2].slice(0, 1) == 5">其他谐音、近形错误，建议替换</span>
                    <span v-else-if="item1[2].slice(0, 1) == 3">遗漏字词错误，建议补充</span>
                    <span v-else-if="item1[2].slice(0, 1) == 4">冗余字词错误，建议删减</span>
                    <!--  8-1 未分类 8-2 黄赌毒 8-3 司法、政治 8-4 宗教、迷信 8-5 言语 辱骂 8-6 非法信息 8-7 宣传、广告 -->
                    <span v-else-if="item1[2] == '8-1'">一般敏感词，建议修改</span>
                    <span v-else-if="item1[2] == '8-2'">黄赌毒类词汇，建议修改</span>
                    <span v-else-if="item1[2] == '8-3'">司法、政治词汇，建议修改</span>
                    <span v-else-if="item1[2] == '8-4'">宗教、迷信词汇，建议修改</span>
                    <span v-else-if="item1[2] == '8-5'">言语辱骂，建议修改</span>
                    <span v-else-if="item1[2] == '8-6'">非法信息，建议修改</span>
                    <span v-else-if="item1[2] == '8-7'">宣传、广告，建议修改</span><span v-else-if="item1[2] == '8-8'">反动词汇，建议修改</span><span
                          v-else-if="item1[2] == '8-9'">民生词汇，建议修改</span><span v-else-if="item1[2] == '8-10'">辱骂词汇，建议修改</span>
                    <span v-else-if="item1[2] == '8-11'">贪腐词汇，建议修改</span>
                    <span v-else-if="item1[2] == '8-12'">违法违规，建议修改</span>
                    <span v-else-if="item1[2] == '9-1'">地址归属地错误，建议修改</span>
                    <span v-else-if="item1[2] == '9-2'">日期不合规，建议检查修改</span>
                    <span v-else-if="item1[2] == '10-1'">中英类型错用，建议检查</span>
                    <span v-else-if="item1[2] == '10-2'">成对标点缺失或用反，建议检查</span>
                    <span v-else-if="item1[2] == '10-3'">多余标点，建议删除</span>
                    <span v-else-if="item1[2] == '11-1'">来自重点词校对，建议检查</span>
                    <span v-else-if="item1[2].slice(0, 1) == 7">语序错误，建议调整语序</span>
                    <span v-else>该词无对应分类提示</span>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <ijdDialog :buttonText="dialogInfo.buttonText" :visible="dialogInfo.visible" :type="dialogInfo.type" :title="dialogInfo.title" width="464px"
               @resetPopupData="resetPopupData" @submitPopupData="submitPopupData">
      <el-form @submit.native.prevent ref="wordFormRef" :model="wordForm" :rules="rules" class="login-form" label-width="80px" label-position="top">
        <el-form-item class="login-input-item" v-for="(item, key, index) in wordForm" :key="key" :prop="key"
                      v-show="getLabel(key).label && dialogInfo.type != 'info'">
          <template slot="label">
            <span>{{ getLabel(key).label }}</span>
            <span class="assist-button" v-if="key !== 'code' && key !== 'checkno' && getLabel(key).buttonText"
                  @click="handleButton(key)">{{ getLabel(key).buttonText }}</span>
            <span class="assist-button" v-else-if="getLabel(key).buttonText && codeTextConfig.value == 1"
                  @click="sendCheckNo(key)">{{ codeTextConfig.text }}</span>
            <span class="assist-button-disabled" v-else-if="getLabel(key).buttonText">{{ codeTextConfig.text }}</span>
          </template>
          <el-select v-model="wordForm[key]" placeholder="请选择" class="ijd-el-select" v-if="key == 'hint'">
            <el-option v-for="item in getLabel(key).hint" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <ijd-input v-else-if="key != 'type' && key != 'word-type-flag'" @handleEnter="handleEnter" :index="index" width="394px" :ref="`ijdInputRef${index}`"
                     :slotType="getLabel(key).slot" :type="getLabel(key).type" :disabled="getLabel(key).disabled" :slotValue="getLabel(key).value"
                     :data="wordForm[key]" :methods="key" @clearValid="clearValid" @setInputValue="setInputValue"></ijd-input>
        </el-form-item>
      </el-form>
      <div v-show="dialogInfo.type == 'info'">
        {{ dialogInfo.text }}
      </div>
    </ijdDialog>
    <ijdDialog class="package" :visible="packInfo.visible" :type="packInfo.type" :title="packInfo.title" width="670px" @resetPopupData="resetPopupData"
               :show-footer=false>
      <div class="nav">
        启用行业词库后，可提高校对精准度，减少行业专有名词的误报。
      </div>
      <div class="main">
        <el-tabs v-model="activeTab" class="dic_tab">
          <el-tab-pane v-for="(tab, index) in tabs" :label="tab.title" :key="index">
            <div class="content">
              <div v-for="(list, listIndex) in tab.lists" :key="listIndex">
                <div class="title">{{ list.title }}</div>
                <ul class="ul" style="display: flex; flex-wrap: wrap">
                  <li v-for="(item, itemIndex) in list.items" :key="itemIndex">
                    <el-checkbox v-model="item.checkedItems" :disabled="item.must_be_used === 1" :checked="item.selected === 1 || item.must_be_used === 1"
                                 :label="item" @change="handleCheckboxChange(item.checkedItems, item.uuid)">
                      {{ item.name }}
                    </el-checkbox>
                  </li>
                </ul>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </ijdDialog>
  </div>
</template>
  
  <script>
// import { quillEditor } from "vue-quill-editor";
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// import ijdButton from '../../components/Button.vue'
// import ijdTag from '../../components/Tag.vue'
// import api from '../../api/checkApi'
// import team from '../../api/enterprise'
// import animate from '../../utils/animate'
// import ijdDialog from '../../components/Dialog.vue'
// import ijdInput from '../../components/Input.vue'
export default {
  data() {
    return {
      waitCheckId: false,
      checkResultStorage: [],
      // 显示/隐藏高频词
      showRespeat: true,
      // 高频词列表
      respeatArr: [],
      // 校对模式
      checkMode: 3,
      resetArr: [],
      checkId: {
        id: '',
        time: '',
        cancel: false
      },
      checkInfo: {},
      scrollTip: '',
      // 编辑器滚动条显示隐藏定时器
      scrollEditor: '',
      editTimer: '',
      editError: false,
      // 编辑器滚动高度
      scrollTop: 0,
      highTimer: '',
      // 文本改变时立即停止校对
      changeProtect: false,
      // 取消校对
      cancelProtect: false,
      timer: '',
      id: 0,
      popupIndex: 0,
      // 加入词库按钮的禁用/停用
      dropDisabled: true,
      wordCopy: '',
      wordForm: {
        word: '',
        recommend: '',
        hint: '',
      },
      rules: {
        word: [
          { required: true, message: '请填写该选项', trigger: 'click' }
        ]
      },
      exampleText: `《校对示例》<br>党的十八大以来，以习近平主席为核心的党中央引领我国经济社会发展取得历史性成就、发生历史性变革，在实践中形成和发展了习近平经济思想，为新征程上做好经济工作提供了行动指南。<br/>近段时间发布的多个数据显示，，餐饮、文旅等线下消费热度上升，全国各地的“烟火气”火速回归，为提振全年经济开了好头。作为拉动我国经济增涨的“第一动力”，消费升温为上下游市场负苏增添了暖意。业内专家指出，随着传统消回暖，叠加IP消费、健康消费、兴趣消费等新增长增长点的迅速崛起，消费增长的结构性潜力将加快释放，我国经济回稳之势进一步确立。<br/>二O二三年以来，餐饮、电影、旅游多种等消费快速恢复。餐厅等位已成常态，春节期间，湖北长沙文和友海信广场店以排队超过4500桌冲上了微博热搜。电影票房也迎来高增长，猫眼电影数据展示，截至2月6日，春节档电影《满江红》和《流浪地球2票房总额已超82亿元。 国信中心大数据发展部研究员表示，各地市委政府多项高频消费数据反映今年以来我国消费市场持续回暖。线下消费热度快速恢复，至2月31日已较去年12月的低点大幅提升22.8个点,各大商圈人气日渐兴旺.`,
      example: [{ "sentence": "《校对示例》党的十八大以来，以习近平主席为核心的党中央引领我国经济社会发展取得历史性成就、发生历史性变革，在实践中形成和发展了习近平经济思想，为新征程上做好经济工作提供了行动指南。近段时间发布的多个数据显示，，餐饮、文旅等线下消费热度上升，全国各地的“烟火气”火速回归，为提振全年经济开了好头。作为拉动我国经济增涨的“第一动力”，消费升温为上下游市场负苏增添了暖意。业内专家指出，随着传统消回暖，叠加IP消费、健康消费、兴趣消费等新增长增长点的迅速崛起，消费增长的结构性潜力将加快释放，我国经济回稳之势进一步确立。二O二三年以来，餐饮、电影、旅游多种等消费快速恢复。餐厅等位已成常态，春节期间，湖北长沙文和友海信广场店以排队超过4500桌冲上了微博热搜。电影票房也迎来高增长，猫眼电影数据展示，截至2月6日，春节档电影《满江红》和《流浪地球2票房总额已超82亿元。 国信中心大数据发展部研究员表示，各地市委政府多项高频消费数据反映今年以来我国消费市场持续回暖。线下消费热度快速恢复，至2月31日已较去年12月的低点大幅提升22.8个点,各大商圈人气日渐兴旺.", "position": 0, "shareDicId": null, "mistakes": [[[14, 27], [["以习近平同志为核心的党中央", 3, "8-1", -1]]], [[103, 105], [[null, 8, "10-3", 0]]], [[155, 157], [["增长", 2, "1-1", 0]], []], [[175, 177], [["复苏", 2, "2-1", 0]], []], [[194, 195], [[null, 2, "3-1", -1]], []], [[216, 218], [[null, 2, "4-1", -1]], []], [[257, 261], [["二〇二三", 2, "5-", -1]]], [[273, 276], [[null, 2, "7-1", -1]], []], [[297, 301], [["湖南省长沙县", 2, "9-1", 0]]], [[344, 346], [["显示", 1, "5-2", 0]], []], [[365, 366], [[null, 8, "10-2", 0]]], [[383, 387], [["国家信息中心", 2, "0-", -1]]], [[401, 405], [["市委市政府", 2, "3-", -1]]], [[442, 447], [[null, 2, "9-2", 0]]], [[467, 468], [["，", 8, "10-1", 0]]], [[478, 479], [["。", 8, "10-1", 0]]]], "mistakeNum": 0 }],
      dialogInfo: {
        visible: false,
        title: '加入错词',
        buttonText: '确认',
        type: 'error',
        width: '400px',
        text: '',
      },
      // 校对按钮
      checkConfig: {
        method: 'checkText',
        buttonText: '立即校对',
        disabled: false,
        loading: false
      },
      // 行距配置
      lineConfig: {
        value: 1,
        text: '行距正常',
        list: [
          {
            value: 2,
            text: '行距缩小'
          },
          {
            value: 3,
            text: '行距扩大'
          }
        ]
      },
      content: ``,
      editorOption: {
        placeholder: '请输入需校对的文本'
      },
      revokeText: '撤销',
      showVal: 'v1',
      // showTips: '',
      // 错别字
      miss: [],
      // 修改建议
      advice: [],
      // 错别字的偏移量
      arr: [],
      originalArr: [],
      // 句子
      sentence: [],
      checkContent: [],
      checkObject: {
        advice: [],
        arr: [],
        miss: [],
        sentence: [],
        highlight: [],
        arrCopy: [],
        arrIndex: []
      },
      checki: [],
      ignores: [],
      highlight: [],
      arrCopy: [],
      arrIndex: [],
      contentCopy: [],
      position: 0,
      undo: false,
      some: 0,
      someIndex: [],
      // 判断编辑器滚动是否结束
      scrollStop: false,
      list: [],
      textIndex: 1,
      highlightPosition: [],
      editorRef: null,
      wrapperRef: null,
      wrapperInfo: {},
      adviceFirst: [],
      textLength: 0,
      filterParams: {
        all: '',
        high: 'rgba(0, 0, 0, 0)',
        low: 'rgba(0, 0, 0, 0)',
        sensitive: 'rgba(0, 0, 0, 0)',
        symbol: 'rgba(0, 0, 0, 0)',
        custom: 'rgba(0, 0, 0, 0)'
      },
      isMounted: false,
      packgeText: '行业词库',
      packInfo: {
        visible: false,
        title: '行业词库设置',
        buttonText: '确认',
        type: 'showPackage',
        width: '400px',
        text: '',
      },
      checkedUuids: [], // 用于保存已选中的 uuid 的数组
      checkedItems: [],
      activeTab: '',
      tabs: []
    }
  },
  props: ['loginOrigin'],
  // components: {
  //   quillEditor,
  //   ijdButton,
  //   ijdTag,
  //   ijdDialog,
  //   ijdInput
  // },
  // computed: {
  //   notice() {
  //     return this.$store.state.noticeList
  //   },
  //   showTips() {
  //     if (this.$store.state.noticeList.length) {
  //       return ''
  //     } else {
  //       return 'v1'
  //     }
  //   },
  //   dictionary_id() {
  //     return this.$store.state.dictionary_id
  //   },
  //   filterNum() {
  //     let num = 0
  //     if (this.filterParams.high == '') {
  //       num += this.computedTipsNumber(1)
  //     }
  //     if (this.filterParams.low == '') {
  //       num += this.computedTipsNumber(2)
  //     }
  //     if (this.filterParams.sensitive == '') {
  //       num += this.computedTipsNumber(3)
  //     }
  //     if (this.filterParams.symbol == '') {
  //       num += this.computedTipsNumber(4)
  //     }
  //     if (this.filterParams.custom == '') {
  //       num += this.computedTipsNumber(5)
  //     }
  //     return num
  //   },
  //   undoInfo() {
  //     if (this.position < this.contentCopy.length && this.contentCopy.length) {
  //       return false
  //     } else {
  //       return true
  //     }
  //   },
  //   checkResult() {
  //     return this.$store.state.socketResult.checkResult
  //   },
  //   checkNo() {
  //     return this.$store.state.socketResult.checkId
  //   }
  // },
  watch: {
    content: {
      handler(val, oldVal) {
        const newValue = val
        const oldValue = oldVal
        window.sessionStorage.setItem('content', this.content || '')
        if (this.undo == false && oldVal && !this.editError) {
          this.textChange(newValue.replace(/<.*?>/g, ""), oldValue.replace(/<.*?>/g, ""))
        }
        this.$nextTick(() => {
          this.textLength = this.$refs.myQuillEditor.quill.getLength() - 1
        })
      }
    },
    checkResult(val) {
      this.handleReuslt(val)
    },
    checkNo(val) {
      if (val.id == this.checkId.id || this.waitCheckId) {
        this.checkConfig.buttonText = '立即校对'
        this.checkConfig.loading = false
        // this.checkContent = text
        if (this.loginOrigin) {
          this.$store.dispatch('getHighSpeedNumber')
          this.$emit('rightsDialog')
        }
        this.changeProtect = false
      } else {
        const keys = Object.keys(JSON.parse(JSON.stringify(this.checkInfo)))
        if (keys.length == 0) {
          this.miss = []
          this.advice = []
          this.arr = []
          this.checkConfig.buttonText = '立即校对'
          this.checkConfig.loading = false
          this.$message.warning('校对异常，请再次点击校对')
          // this.checkContent = text
          if (this.loginOrigin) {
            this.$store.dispatch('getHighSpeedNumber')
          }
          this.changeProtect = false
        }
        console.log(val.id, this.checkInfo, this.checkId.id)
      }
    },
    'dialogInfo.visible': {
      handler(val) {
        if (val) {
          this.getFocus(0)
        }
      }
    }
  },
  // mounted() {
  //   if (window.localStorage.getItem("show")) {
  //     this.showTips = window.localStorage.getItem("show");
  //   }
  //   let popup = document.querySelector('.display-miss')
  //   this.textLength = this.$refs.myQuillEditor.quill.getLength() - 1
  //   let ql = document.querySelector('.ql-editor')
  //   let high = document.querySelector('.highlight')
  //   let tc = document.querySelector('.tip-container-show')
  //   tc.className = 'tip-container-show tip-container-none'
  //   this.wrapperInfo = ql.getBoundingClientRect();
  //   if (!window.sessionStorage.content && !this.loginOrigin) {
  //     this.content = this.exampleText
  //     setTimeout(() => {
  //       this.textLength = this.$refs.myQuillEditor.quill.getLength() - 1
  //       this.handleText(this.example, 0, 0)
  //     }, 100)
  //   } else if (!this.$route.query.text) {
  //     this.$nextTick(() => {
  //       this.content = window.sessionStorage.getItem('content')
  //     })
  //   }
  //   this.$nextTick(() => {
  //     this.$refs.myQuillEditor.quill.focus()
  //     if (this.$route.query.text) {
  //       this.content = this.$route.query.text
  //       this.$router.push('/')
  //       setTimeout(() => {
  //         this.checkText()
  //       }, 500)
  //     }
  //   })
  //   let windowChangeTimer = ''
  //   window.addEventListener('scroll', () => {
  //     clearTimeout(windowChangeTimer)
  //     if (this.advice.length) {
  //       windowChangeTimer = setTimeout(() => {
  //         this.resetHigh()
  //       }, 500)
  //     }
  //   })
  //   window.addEventListener('resize', () => {
  //     clearTimeout(windowChangeTimer)
  //     if (this.advice.length) {
  //       windowChangeTimer = setTimeout(() => {
  //         this.resetHigh()
  //       }, 500)
  //     }
  //   })
  //   ql.addEventListener('scroll', () => {
  //     clearTimeout(this.scrollEditor)
  //     this.scrollTop = ql.scrollTop
  //     this.$refs.ijdHighRef.style.top = ql.scrollHeight + 'px'
  //     this.$refs.ijdHighRef.style.height = 20 + 'px'
  //     this.$refs.ijdHighRef.style.width = 20 + 'px'
  //     high.scrollTop = ql.scrollTop
  //     popup.style.display = 'none'
  //     ql.className = 'ql-editor ql-editor-display'
  //     this.scrollEditor = setTimeout(() => {
  //       ql.className = 'ql-editor ql-editor-none'
  //     }, 2000)
  //   })
  //   this.$refs.myQuillEditor.quill.on('selection-change', (range) => {
  //     if (range && range.length > 0) {
  //       this.watchSelect()
  //     } else {
  //       setTimeout(() => {
  //         this.dropDisabled = true;
  //       }, 200)
  //     }
  //   })
  //   tc.addEventListener('scroll', () => {
  //     tc.className = 'tip-container-show'
  //     clearTimeout(this.scrollTip)
  //     this.scrollTip = setTimeout(() => {
  //       tc.className = 'tip-container-show tip-container-none'
  //     }, 2000)
  //   })
  //   popup.addEventListener('mouseenter', () => {
  //     let tag = document.querySelectorAll('.ijd-high-light')
  //     clearTimeout(this.timer)
  //     popup.style.display = 'block'
  //     this.highlightTag(tag, this.popupIndex, this.id)
  //   })
  //   popup.addEventListener('mouseleave', () => {
  //     let tag = document.querySelectorAll('.ijd-high-light')
  //     popup.style.display = 'none'
  //     this.leavelightTag(tag, this.popupIndex, this.id)
  //   })
  //   ql.addEventListener('mousemove', (e) => {
  //     clearTimeout(this.highTimer)
  //     this.highTimer = setTimeout(() => {
  //       let x, y
  //       x = e.x - this.wrapperInfo.left
  //       y = e.y - this.wrapperInfo.top + this.scrollTop
  //       let tag = document.querySelectorAll('.ijd-high-light')
  //       let container = document.querySelector('.tip-container-show')
  //       let tip = document.querySelectorAll('.check-tips')
  //       // console.log('tag', tag)
  //       if (tag.length) {
  //         this.highlightPosition.forEach((item, index) => {
  //           let idName = tag[index].getAttribute('id')
  //           let id = Number(idName)
  //           if ((item.x[0] < x && x < item.x[1]) && (item.y[0] < y && y < item.y[1])) {
  //             this.highlightTag(tag, index, id)
  //             let h = Math.floor(container.offsetHeight / 2)
  //             this.adviceFirst = this.advice[id][0];
  //             this.id = id
  //             this.popupIndex = index
  //             popup.style.display = 'block'
  //             popup.style.left = item.x[0] - 40 + 'px'
  //             popup.style.top = this.wrapperInfo.top + (item.y[1] || (item.y[0] + 20)) + 2 + window.scrollY - ql.scrollTop + 'px'
  //             clearTimeout(this.timer)
  //             this.timer = setTimeout(() => {
  //               popup.style.display = 'none'
  //             }, 3000)
  //             if (tip[id]) {
  //               animate(container, tip[id].offsetTop - h + 200)
  //             }
  //             this.missCard(id, this.advice[id])
  //           } else {
  //             if (id && id != this.id) {
  //               this.missCardLeave(id, this.advice[id])
  //               this.leavelightTag(tag, index, id)
  //             }
  //           }
  //         })
  //       }
  //     }, 100)
  //   })
  // },
  deactivated() {
    this.$notify.closeAll();
  },
  methods: {
    handleReuslt(val, type = false) {
      const keys = Object.keys(JSON.parse(JSON.stringify(this.checkInfo)))
      const index = keys.indexOf(val.id)
      // console.log(index, keys, val)
      if (index !== -1) {
        if (this.changeProtect == false || type) {
          this.handleText(val.check_result, this.checkInfo[val.id] - val.para_no, index, val.para_no)
        } else {
          this.cancelCheck()
        }
      } else if (this.waitCheckId && !type) {
        this.checkResultStorage.push(val)
      }
    },
    batchWrongly(item, type) {
      switch (type) {
        case 1: {
          this.wordForm = {
            edit: item.advice[0] || '',
            miss: this.miss[item.someIndex[0]],
            index: String(item.someIndex[0]),
            someIndex: JSON.stringify(item.someIndex),
            type: type,
          },
            this.dialogInfo = {
              visible: true,
              title: '全部应用',
              buttonText: '确认',
              type: 'batching',
              width: '500px',
              text: '全部修改'
            }
          // this.handleWrongly('editAll', item.someIndex[0], 0, item.advice[0], item.someIndex)
          break
        }
        case 2: {
          this.someIndex = item.someIndex
          this.handleWrongly('ignoreAll', item.someIndex[0], 0)
          break
        }
      }
    },
    changeShowRespeat() {
      this.showRespeat = !this.showRespeat
      if (!this.showRespeat) {
        this.$refs.respeatIconRef.style.transform = 'rotate(180deg)'
      } else {
        this.$refs.respeatIconRef.style.transform = 'rotate(0)'
      }

    },
    getSomeNumber(word, i, advice) {
      let some = 0;
      const someIndex = [];
      for (let k = 0; k < this.miss.length; k++) {
        if (this.miss[k] == word && this.advice[k][0].slice(-2)[0][0] == 1 && this.advice[k][0][0] == advice) {
          if (i <= k) {
            some++;
            someIndex.push(k);
          } else {
            break
          }
        }
      }
      return {
        some,
        someIndex
      }
    },
    getRespeatTip() {
      const respeatArr = []
      this.miss.forEach((item, index) => {
        if (this.advice[index][0].slice(-2)[0][0] == 1) {
          const obj = this.getSomeNumber(item, index, this.advice[index][0][0])
          if (obj.some > 1) {
            // console.log(index, this.advice[index][0])
            respeatArr.push({
              ...obj,
              advice: this.advice[index][0]
            })
          }
        }
      })
      this.respeatArr = respeatArr
    },
    changeCheckMode() {
      this.checkMode = this.checkMode == 3 ? 2 : 3
    },
    getOS() {
      // var sUserAgent = navigator.userAgent;
      var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");

      var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");

      if (isMac) return 134218241;
      else if (isWin) return 67109377
      else return 33554945
    },
    collectCheck(data, type = 1, num = 0) {
      let object
      if (type == 1) {
        object = {
          check_id: data.id,
          check_type: 1,
          check_tool: this.getOS(),
          cue_word: data.advice,
          index: [data.offset[0] + num, data.offset[1] + num],
          feedback_type: data.type,
          date: data.date,
          pre_word: data.miss,
          sentence: ''
        }
        if (this.loginOrigin && object.cue_word[0] && object.cue_word[0][1] !== 8) {
          api.checkOpertorCollect(object).then(() => {
          })
        }
      } else {
        object = {
          check_id: data.id,
          check_type: 1,
          check_tool: this.getOS(),
          reset_word: data.advice,
          offset: data.offset,
          operation_type: 1,
        }
        if (this.loginOrigin && object.reset_word[0] && object.reset_word[0][1] !== 8) {
          api.otherOpertorCollect(object).then(() => {
          })
        }
      }
    },
    cancelCheck() {
      console.log('取消了', this.checkId.cancel)
      if (this.checkId.cancel == false) {
        this.checkId.cancel = true
        const id = this.checkId.id
        api.cancelCheck({ id, section_sum: Object.keys(this.checkInfo).length }).then((res) => {
          if (res.status == 200) {
            this.checkConfig.buttonText = '立即校对'
            this.checkConfig.loading = false
            // this.checkContent = text
            if (this.loginOrigin) {
              this.$store.dispatch('getHighSpeedNumber')
            }
            this.changeProtect = false
          }
        })
      }
    },
    highlightTag(tag, index, id) {
      switch (this.advice[id][0][1]) {
        case 2: {
          tag[index].className = 'ijd-high-light light-high-bottom light-high'
          break
        }
        case 1: {
          tag[index].className = 'ijd-high-light light-low-bottom light-low'
          break
        }
        case 3: {
          tag[index].className = 'ijd-high-light light-sensitive-bottom light-sensitive'
          break
        }
        case 8: {
          tag[index].className = 'ijd-high-light light-symbol-bottom light-symbol'
          break
        }
        default: {
          tag[index].className = 'ijd-high-light light-custom-bottom light-custom'
          break
        }
      }
    },
    leavelightTag(tag, index, id) {
      if (!this.advice[id]) {
        return
      }
      switch (this.advice[id][0][1]) {
        case 2: {
          tag[index].className = 'ijd-high-light light-high-bottom'
          break
        }
        case 1: {
          tag[index].className = 'ijd-high-light light-low-bottom'
          break
        }
        case 3: {
          tag[index].className = 'ijd-high-light light-sensitive-bottom'
          break
        }
        // case 4: {
        //     tag[index].className = 'ijd-high-light light-sensitive-bottom'
        //     break
        // }
        // case 5: {
        //     tag[index].className = 'ijd-high-light light-high-bottom'
        //     break
        // }
        // case 7: {
        //     tag[index].className = 'ijd-high-light light-high-bottom'
        //     break
        // }
        // case 6: {
        //     tag[index].className = 'ijd-high-light light-sensitive-bottom'
        //     break
        // }
        case 8: {
          tag[index].className = 'ijd-high-light light-symbol-bottom'
          break
        }
        default: {
          tag[index].className = 'ijd-high-light light-custom-bottom'
          break
        }
      }
    },
    handleResultWord(item) {
      let arr = []
      switch (item[1]) {
        case 8: {
          if (item[0]) {
            arr = item[0].split('或')
            break
          }
        }
      }
      if (arr.length > 1) {
        return {
          value: arr,
          display: true
        }
      } else {
        return {
          value: item[0],
          display: false
        }
      }
    },
    changeText() {
      if (this.checkConfig.loading) {
        this.changeProtect = true
        this.cancelCheck()
      }
    },
    getTextLengthVisible(type) {
      let params = {
        text: '',
        visible: false
      }
      switch (type) {
        case 1: {
          if (this.loginOrigin) {
            if (this.$store.state.myRole == 'free' && this.textLength > 5000) {
              params.text = '请将文本缩减至5000（含5000）字以内即可校对。'
              params.visible = true
            } else if (this.$store.state.myRole !== 'free' && this.textLength > 10000) {
              params.text = '请将文本缩减至1万（含1万）字以内即可校对。'
              params.visible = true
            } else {
              params.visible = false
            }
          } else if (this.textLength > 500) {
            params.text = '未登录用户单次校对字数为500（含500）字，登录后解除该限制。'
            params.visible = true
          } else {
            params.visible = false
          }
          break
        }
        case 2: {
          if (this.loginOrigin) {
            if (this.$store.state.myRole == 'free' && this.textLength > 5000) {
              params.visible = false
            } else if (this.$store.state.myRole !== 'free' && this.textLength > 10000) {
              params.visible = false
            } else {
              params.visible = true
            }
          } else if (this.textLength > 500) {
            params.visible = false
          } else {
            params.visible = true
          }
          break
        }
      }
      return params

    },
    handleTips(message, info, type) {
      // this.$notify.closeAll();
      if (type != 1) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: `<div class="notify-tip"><span>${message}</span></div>
                      <div class="notify-button"><button class="find">${info}</button></div>
                      `,
          duration: 5000,
        });
      } else {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: `<div class="notify-tip"><span>${message}</span></div>
                      <div class="notify-button"><button class="find-download">去下载</button></div>
                      `,
          duration: 5000,
        });
        let download = document.querySelectorAll(".find-download");
        download.forEach((item) => {
          item.addEventListener("click", () => {
            if (type == 1) {
              window.open('https://www.ijiaodui.com/index.php?id=xiazai')
            }
            this.$notify.closeAll();
          });
        });
      }
      let look = document.querySelectorAll(".find");
      look.forEach((item) => {
        item.addEventListener("click", () => {
          if (type == 1) {
            this.$router.push("/document");
          } else if (type == 2) {
            this.$emit("editValue", 'visible', true);
          } else {
            this.content = this.exampleText
            setTimeout(() => {
              this.textLength = this.$refs.myQuillEditor.quill.getLength() - 1
              this.handleText(this.example, 0, 0)
            }, 100)
          }
          this.$notify.closeAll();
        });
      });
    },
    watchSelect() {
      setTimeout(() => {
        let range = this.$refs.myQuillEditor.quill.getSelection(true);
        let delta = this.$refs.myQuillEditor.quill.getContents(
          range.index,
          range.length
        );
        this.dropDisabled = true;
        this.selectDisabled = true;
        this.words = "";
        console.log(range.index);
        if (delta.ops.length) {
          for (let i = 0; i < delta.ops.length; i++) {
            let arr = delta.ops[i].insert.split("\n");
            if (arr.length) {
              arr.forEach((item, index) => {
                if (index == arr.length - 1) {
                  this.words += item;
                } else {
                  this.words += item + "<br>";
                }
              });
            }
          }
          if (this.words.length >= 2 && this.words.length <= 16) {
            this.dropDisabled = false;
            this.wordCopy = this.words.replace(/<br>/g, "");
          }
          if (this.words.length > 0) {
            this.selectDisabled = false;
          }
          // console.log(delta,this.words)
        }
      }, 0);
    },
    handleEnter(index) {
      this.getFocus(index + 1)
    },
    getFocus(index) {
      this.$nextTick(() => {
        if (this.$refs[`ijdInputRef${index}`] && this.$refs[`ijdInputRef${index}`].length) {
          this.$refs[`ijdInputRef${index}`][0].$children[0].focus()
        } else if (index != 0) {
          this.submitPopupData(this.dialogInfo.type)
        }
      })
    },
    clearValid(type) {
      this.$refs.wordFormRef.clearValidate(type)
    },
    setInputValue(value, type) {
      this.wordForm[type] = value
    },
    getLabel(key) {
      let params = {
        label: '',
        slot: '',
        value: '',
        buttonText: '',
        disabled: false,
        type: 'text',
        hint: []
      }
      switch (key) {
        case 'word': {
          if (this.dialogInfo.type == 'error' || this.dialogInfo.type == 'team-error') {
            params.label = '错词'
          } else {
            params.label = '敏感词'
          }
          break
        }
        case 'hint': {
          params.label = '词汇分类'
          if (this.dialogInfo.type == 'error' || this.dialogInfo.type == 'team-error') {
            params.hint = this.$store.state.errorOptions
          } else {
            params.hint = this.$store.state.hintOptions
          }
          break
        }
        case 'recommend': {
          params.label = '建议修改为'
          break
        }
        case 'edit': {
          params.label = `将${this.wordForm.miss || ''}修改为`
        }

      }
      return params
    },
    // 点击取消的事件
    resetPopupData() {
      //  这里可重置数据
      this.dialogInfo.visible = false
      this.packInfo.visible = false
      this.activeTab = "0"
    },
    // 点击确定的按钮
    async submitPopupData(val) {
      switch (val) {
        case 'error': {
          if (this.wordForm.word == '') {
            return this.$message.error('错词不能为空')
          }
          api.addWord(this.wordForm).then((res) => {
            if (res.status == 200) {
              // this.handMiss(i,j,type)
              this.$message.success("错词添加成功");
              this.wordForm = {
                word: '',
                recommend: "",
                hint: "",
                type: 2,
              }
            }
          });
          break
        }
        case 'certain': {
          if (this.wordForm.word == '') {
            return this.$message.error('敏感词不能为空')
          }
          api.addWord(this.wordForm).then((res) => {
            if (res.status == 200) {
              // this.handMiss(i,j,type)
              this.$message.success("敏感词添加成功");
              this.wordForm = {
                word: '',
                recommend: "",
                hint: "",
                type: 3,
              }
            }
          });
          break
        }
        case 'team-error': {
          if (this.wordForm.word == '') {
            return this.$message.error('错词不能为空')
          }
          team.addTeamWord(this.wordForm).then((res) => {
            if (res.status == 200) {
              this.$message.success("错词添加成功");
              this.wordForm = {
                word: '',
                recommend: "",
                hint: "",
                type: 3,
              }
            }
          })
          break
        }
        case 'team-certain': {
          if (this.wordForm.word == '') {
            return this.$message.error('敏感词不能为空')
          }
          team.addTeamWord(this.wordForm).then((res) => {
            if (res.status == 200) {
              this.$message.success("敏感词添加成功");
              this.wordForm = {
                word: '',
                recommend: "",
                hint: "",
                type: 3,
              }
            }
          })
          break
        }
        case 'info': {
          this.checkContent = []
          this.checkText()
          break
        }
        case 'batching': {
          this.handleWrongly('editAll', Number(this.wordForm.index), 0, this.wordForm.edit, JSON.parse(this.wordForm.someIndex))
          break
        }
      }
      this.dialogInfo.visible = false
    },
    addWords(type) {
      if (!this.loginOrigin) {
        return this.$emit('editValue', 'visible', true)
      }
      if (this.wordCopy != "") {
        let right = {
          word: this.wordCopy,
          recommend: "",
          hint: "",
          type: type,
        };
        if (type < 4) {
          switch (type) {
            case 2: {
              this.wordForm = {
                word: this.wordCopy,
                recommend: "",
                hint: "1-",
                type: type,
              },
                this.dialogInfo = {
                  visible: true,
                  title: '加入错词',
                  buttonText: '确认',
                  type: 'error',
                  width: '500px'
                },
                this.hintOptions = this.$store.state.errorOptions
              break
            }
            case 3: {
              this.wordForm = {
                word: this.wordCopy,
                recommend: "",
                hint: "8-1",
                type: type,
              },
                this.dialogInfo = {
                  visible: true,
                  title: '加入敏感词',
                  buttonText: '确认',
                  type: 'certain',
                  width: '500px'
                },
                this.hintOptions = this.$store.state.hintOptions
              break
            }
            case 1: {
              api.addWord(right).then((res) => {
                if (res.status == 200) {
                  // this.handMiss(i,j,type)
                  this.$message.success("添加成功");
                }
              });
            }
          }
          return
        } else {
          switch (type) {
            case 4: {
              this.wordForm = {
                word: this.wordCopy,
                recommend: "",
                hint: "",
                'word-type-flag': 1,
                dictionary_id: this.dictionary_id,
              },
                team.addTeamWord(this.wordForm).then((res) => {
                  if (res.status == 200) {
                    this.$message.success("添加成功");
                  }
                })
              break
            }
            case 5: {
              this.wordForm = {
                word: this.wordCopy,
                recommend: "",
                hint: "1-",
                'word-type-flag': 2,
                dictionary_id: this.dictionary_id,
              },
                this.dialogInfo = {
                  visible: true,
                  title: '加入错词(共享词库)',
                  buttonText: '确认',
                  type: 'team-error',
                  width: '500px'
                },
                this.hintOptions = this.$store.state.errorOptions
              break
            }
            case 6: {
              this.wordForm = {
                word: this.wordCopy,
                recommend: "",
                hint: "8-1",
                'word-type-flag': 3,
                dictionary_id: this.dictionary_id,
              }
              this.dialogInfo = {
                visible: true,
                title: '加入敏感词(共享词库)',
                buttonText: '确认',
                type: 'team-certain',
                width: '500px'
              },
                this.hintOptions = this.$store.state.hintOptions
              break
            }
          }
        }
      }
    },
    handleSome(i) {
      this.some = 0;
      this.someIndex = [];
      this.miss.forEach((item, index) => {
        if (this.miss[i] == item) {
          this.some++;
          this.someIndex.push(index);
        }
      });
    },
    computeThisSome(i) {
      let some = 0;
      this.miss.forEach((item) => {
        if (this.miss[i] == item) {
          some++;
        }
      });
      return some
    },
    handleIgnore(type, index, index1) {
      if (type == 1) {
        this.handleWrongly('ignore', index, index1)
      } else {
        this.handleSome(index)
        this.handleWrongly('ignoreAll', index, index1)
      }
    },
    handleAdviceType(index) {
      let type = 1
      if (this.advice[index]) {
        for (let i = 0; i < this.advice[index].length; i++) {
          if (this.advice[index][i][1] == 6 || this.advice[index][i][1] == 7) {
            type = 3
            break
          } else if (this.advice[index][i][1] == 4 || this.advice[index][i][1] == 5) {
            type = 2
            break
          }
        }
      }
      return type
    },
    teamDicType(index) {
      if (this.miss[index].length > 1 && this.loginOrigin && this.handleAdviceType(index) != 3 && this.$store.state.myRole != 'user' && this.$store.state.myRole != 'free' && this.$store.state.myRole != 'user_admin') {
        return true
      } else {
        return false
      }
    },
    addWord(params, i, j, type, word) {
      if (!this.loginOrigin) {
        return this.$emit('editValue', 'visible', true)
      }
      this.handleSome(i)
      if (word != "") {
        let right = {
          word: word,
          recommend: "",
          hint: "1-",
          type: 1,
        };
        if (params == 1) {
          api.addWord(right).then((res) => {
            if (res.status == 200) {
              this.$message({
                showClose: true,
                message: `添加成功`,
                type: "success",
                offset: 84,
              });
              this.handleWrongly(type, i, j);
            }
          });
        } else if (params == 2) {
          this.wordForm = {
            word: word,
            recommend: "",
            hint: "",
            'word-type-flag': 1,
            dictionary_id: this.dictionary_id,
          },
            team.addTeamWord(this.wordForm).then((res) => {
              if (res.status == 200) {
                this.$message({
                  showClose: true,
                  message: `添加成功`,
                  type: "success",
                  offset: 84,
                });
                this.handleWrongly(type, i, j);
              }
            })
        }
      }
    },
    copyText() {
      const input = document.createElement("textarea");
      //  var parser = new DOMParser();
      // var doc=parser.parseFromString(this.content, "text/xml");
      let arr = document.querySelector(".ql-editor").innerText.split("\n");
      let word = "";
      let num = 0;
      arr.forEach((item, index) => {
        if (index == arr.length - 1) {
          word += item;
        } else if (item != "") {
          word += item + "\n";
          num = 0;
        } else if (arr[index + 1] == "") {
          if (num == 0) {
            num = 1;
          } else {
            word += "\n";
            num = 0;
          }
        }
      });
      input.value = word;
      document.body.appendChild(input);
      // console.log(document.querySelector('.ql-editor').innerText.split('\n'))
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("已复制到剪贴板");
      }
      document.body.removeChild(input);
    },
    clearText() {
      this.miss = [];
      this.range = [];
      this.advice = [];
      this.arrIndex = [];
      this.arrCopy = []
      this.arr = []
      this.highlight = []
      this.content = "";
    },
    lineControl(value) {
      // console.log(value)
      let ql = document.querySelector('.ql-editor')
      let list = [
        {
          value: 1,
          text: '行距正常',
          style: '40px'
        },
        {
          value: 2,
          text: '行距缩小',
          style: '26px'
        },
        {
          value: 3,
          text: '行距扩大',
          style: '54px'
        }
      ]
      this.lineConfig.list = []
      list.forEach(item => {
        if (value == item.value) {
          this.lineConfig.value = item.value
          this.lineConfig.text = item.text
          ql.style.lineHeight = item.style
        } else {
          this.lineConfig.list.push(item)
        }
      })
      this.$nextTick(() => {
        setTimeout(() => {
          this.resetHigh()
        }, 1000)
      })
    },
    deepClone(obj) {
      //判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
      var objClone = Array.isArray(obj) ? [] : {};
      //进行深拷贝的不能为空，并且是对象或者是
      if (obj && typeof obj === "object") {
        for (let key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (obj[key] && typeof obj[key] === "object") {
              objClone[key] = this.deepClone(obj[key]);
            } else {
              objClone[key] = obj[key];
            }
          }
        }
      }
      return objClone;
    },
    textChange(val, old) {
      // let select =  window.getSelection()
      val = val.replace(/&nbsp;/ig, " ")
      old = old.replace(/&nbsp;/ig, " ")
      let range = window.getSelection().getRangeAt(0)
      // text = text.replace(/\r|\n/ig, "")
      val = val.replace(/\r|\n/ig, "")
      // old = old.replace(/<p.*?>|<\/p>/g, "")
      old = old.replace(/\r|\n/ig, "")
      if (old == val) {
        this.resetHigh()
      } else {
        let index = 0
        let l = val.length - old.length
        // for(let i in val){
        //   if(val[i]!=old[i]){
        //     index = Number(i)
        //     break
        //   }
        // }
        let nodeList = this.handleNodeList()
        nodeList = nodeList.flat(Infinity)
        for (let item of nodeList) {
          if (range.startContainer == item) {
            index += range.startOffset
            break
          } else if (item.nodeName == '#text') {
            index += item.length
          }
        }
        for (let i = 0; i < this.arrCopy.length; i++) {
          if (this.arrCopy[i][0] && (this.arrCopy[i][0] >= (index - l))) {
            this.arrCopy[i][0] = this.arrCopy[i][0] + l
            this.arrCopy[i][1] = this.arrCopy[i][1] + l
          }
        }
        const arr = JSON.parse(JSON.stringify(this.arrCopy))
        const missCopy = JSON.parse(JSON.stringify(this.miss))
        let temp = 0
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].length) {
            let miss = val.slice(arr[i][0], arr[i][1])
            // console.log(arr[i][0])
            // console.log(miss,this.miss[i] == miss)
            if (!(missCopy[i] == miss)) {
              this.handMiss(i - temp)
              temp += 1
            }
            // console.log(miss,this.miss[i] == miss)
          }
        }
        this.getRespeatTip()
        // console.log(this.arrCopy)
        if (this.arrCopy.length) {
          this.resetHigh()
        }
      }
    },
    // 统计提示数量
    computedTipsNumber(type) {
      let number = 0
      switch (type) {
        case 0: {
          this.advice.forEach((item) => {
            if (item.length != 0) {
              number++;
            }
          })
          break
        }
        case 1: {
          this.advice.forEach((item) => {
            if (item.length != 0) {
              if (item[0][1] == 2) {
                number++;
              }
            }
          });
          break
        }
        case 2: {
          this.advice.forEach((item) => {
            if (item.length != 0) {
              if (item[0][1] == 1) {
                number++;
              }
            }
          });
          break
        }
        case 3: {
          this.advice.forEach((item) => {
            if (item.length != 0) {
              if (item[0][1] == 3) {
                number++;
              }
            }
          });
          break
        }
        case 4: {
          this.advice.forEach((item) => {
            if (item.length != 0) {
              if (item[0][1] == 8) {
                number++;
              }
            }
          });
          break
        }
        case 5: {
          this.advice.forEach((item) => {
            if (item.length != 0) {
              if (item[0][1] !== 1 && item[0][1] !== 2 && item[0][1] !== 3 && item[0][1] !== 8) {
                number++;
              }
            }
          });
          break
        }
      }
      return number
    },
    // 筛选提示
    filterParamsComputer(item) {
      let judge = true
      switch (item[1]) {
        case 1: {
          if (this.filterParams.all == '' || this.filterParams.low == '') {
            judge = true
          } else {
            judge = false
          }
          break
        }
        case 2: {
          if (this.filterParams.all == '' || this.filterParams.high == '') {
            judge = true
          } else {
            judge = false
          }
          break
        }
        case 3: {
          if (this.filterParams.all == '' || this.filterParams.sensitive == '') {
            judge = true
          } else {
            judge = false
          }
          break
        }
        case 8: {
          if (this.filterParams.all == '' || this.filterParams.symbol == '') {
            judge = true
          } else {
            judge = false
          }
          break
        }
        default: {
          if (this.filterParams.all == '' || this.filterParams.custom == '') {
            judge = true
          } else {
            judge = false
          }
          break
        }
      }
      return judge
    },
    undoEdit() {
      let ql = document.querySelector('.ql-editor')
      const scrollTop = ql.scrollTop
      this.undo = true
      if (this.position < this.contentCopy.length && this.contentCopy.length) {
        this.advice = this.deepClone(this.contentCopy[this.position].advice);
        this.miss = JSON.parse(JSON.stringify(this.contentCopy[this.position].miss));
        this.arr = this.deepClone(this.contentCopy[this.position].arr);
        this.arrIndex = this.deepClone(this.contentCopy[this.position].arrIndex);
        this.arrCopy = this.deepClone(this.contentCopy[this.position].arrCopy);
        this.checkId = this.deepClone(this.contentCopy[this.position].checkId)
        this.$refs.myQuillEditor.quill.deleteText(0, this.textLength);
        this.collectCheck(this.resetArr.pop(), 2)
        this.$nextTick(async () => {
          await this.$refs.myQuillEditor.quill.clipboard.dangerouslyPasteHTML(0, this.contentCopy[this.position].content);
          this.position += 1;
          ql.scrollTop = scrollTop
          await this.resetHigh()
          this.undo = false
          this.getRespeatTip()
        });
      } else {
        this.$message.info("无更多记录");
      }
    },
    // 操作文本：修改、删除、忽略
    async handleWrongly(type, index, index1, result = '', allIndex) {
      // this.missCardLeave(index, item)
      clearTimeout(this.editTimer)
      this.editError = true
      this.editTimer = setTimeout(() => {
        this.editError = false
      }, 500)
      const opertor = {
        edit: 1,
        delete: 1,
        ignore: 3,
        ignoreAll: 3,
        addWord: 4
      }
      const arr = this.originalArr
      let adviceArr = []
      this.advice[index].forEach((item, num) => {
        if (index1 != num) {
          adviceArr.push(item)
        } else {
          adviceArr.unshift(item)
        }
      })
      //   console.log(this.advice[index][0].slice(-1)[0], arr[this.advice[index][0].slice(-1)[0].id])
      const offset = arr[this.advice[index][0].slice(-1)[0].id]
      this.resetArr.push({
        offset: [offset[0] + this.advice[index][0].slice(-1)[0].para_no, offset[1] + this.advice[index][0].slice(-1)[0].para_no],
        advice: this.deepClone(adviceArr),
        id: this.checkId.id,
        date: this.checkId.time,
        type: opertor[type],
        miss: this.miss[index]
      })
      this.collectCheck(this.resetArr.slice(-1)[0], 1)
      let popup = document.querySelector('.display-miss')
      popup.style.display = 'none'
      let copyOne = {
        miss: this.deepClone(this.miss),
        advice: this.deepClone(this.advice),
        content: this.content,
        arr: this.deepClone(this.arr),
        arrCopy: this.deepClone(this.arrCopy),
        arrIndex: this.deepClone(this.arrIndex),
        checkId: this.deepClone(this.checkId)
      };
      this.contentCopy.splice(this.position, 0, copyOne);
      let nodeList = this.handleNodeList().flat(Infinity)
      let l = 0
      let replaceText = ''
      switch (type) {
        case 'edit': {
          if (this.arrIndex[index].length > 1) {
            let al = this.arrIndex[index].length - 1
            this.arrIndex[index].forEach((item, index) => {
              if (index < al) {
                let text = nodeList[item[0]].textContent
                replaceText += text.slice(0, item[1]) + this.advice[index][index1][0].slice(l, l + item[2]) + text.slice(item[1] + item[2])
                nodeList[item[0]].textContent = replaceText
                // handleInputText(id, this.advice[id][0][0].slice(l, l+item[2]).length - item[2])
                replaceText = ''
                l += item[2]

              } else {
                let text = nodeList[item[0]].textContent
                replaceText += text.slice(0, item[1]) + this.advice[index][index1][0].slice(l) + text.slice(item[1] + item[2])
                nodeList[item[0]].textContent = replaceText
                this.handleInputText(index, this.advice[index][index1][0].length - (l + item[2]))
                replaceText = ''
                l += item[2]
              }
            })
          } else {
            this.arrIndex[index].forEach(item => {
              let text = nodeList[item[0]].textContent
              if (result != '') {
                replaceText += text.slice(0, item[1]) + result + text.slice(item[1] + item[2])
              } else {
                replaceText += text.slice(0, item[1]) + this.advice[index][index1][0] + text.slice(item[1] + item[2])
              }
              nodeList[item[0]].textContent = replaceText
              let length = result.length
              if (length == 0 && this.advice[index][index1][0]) {
                length = this.advice[index][index1][0].length
              }
              this.handleInputText(index, length - item[2])
              replaceText = ''
              l += item[2]
            })
          }
          break
        }
        case 'delete': {
          this.arrIndex[index].forEach(item => {
            replaceText = ''
            let text = nodeList[item[0]].textContent
            replaceText += text.slice(0, item[1]) + text.slice(item[1] + item[2])
            nodeList[item[0]].textContent = replaceText
            // this.editNode.focus()
            this.handleInputText(index, -item[2])
            if (replaceText == '') {
              for (let i = 0; i < this.arrIndex.length; i++) {
                if (i > index) {
                  for (let j = 0; j < this.arrIndex[i].length; j++) {
                    this.arrIndex[i][j][0] = this.arrIndex[i][j][0] - this.arrIndex[index].length
                  }
                }
              }
            }
          })
          break
        }
        case 'ignore': {
          this.handleInputText(index, 0)
          break
        }
        case 'ignoreAll': case 'addWord': {
          let l = 0
          for (let j = 0; j < this.someIndex.length; j++) {
            let id = this.someIndex[j] - l
            l++
            // console.log(publicData.arrCopy)
            this.handMiss(id)
            // this.miss[index] = "";
            // this.advice[index].splice(0, Infinity);
          }
          this.resetHigh()
          break
          // this.missCardLeave(index, this.advice[index]);
        }
        case 'editAll': {
          let deleteLength = 0
          for (let i = 0; i < allIndex.length; i++) {
            let id = allIndex[i] - deleteLength
            deleteLength++
            if (this.arrIndex[id].length > 1) {
              let al = this.arrIndex[id].length - 1
              this.arrIndex[id].forEach((item, index) => {
                if (index < al) {
                  let text = nodeList[item[0]].textContent
                  replaceText += text.slice(0, item[1]) + result.slice(l, l + item[2]) + text.slice(item[1] + item[2])
                  nodeList[item[0]].textContent = replaceText
                  // handleInputText(id, this.advice[id][0][0].slice(l, l+item[2]).length - item[2])
                  replaceText = ''
                  l += item[2]

                } else {
                  let text = nodeList[item[0]].textContent
                  replaceText += text.slice(0, item[1]) + result.slice(l) + text.slice(item[1] + item[2])
                  nodeList[item[0]].textContent = replaceText
                  this.handleInputText(id, result.length - (l + item[2]))
                  replaceText = ''
                  l += item[2]
                }
              })
            } else {
              this.arrIndex[id].forEach(item => {
                let text = nodeList[item[0]].textContent
                replaceText += text.slice(0, item[1]) + result + text.slice(item[1] + item[2])
                nodeList[item[0]].textContent = replaceText
                let length = result.length
                // if(length == 0 && this.advice[id][index1][0]) {
                //     length = this.advice[id][index1][0].length
                // }
                this.handleInputText(id, length - item[2])
                replaceText = ''
                l += item[2]
              })
            }
          }
        }
      }
      this.getRespeatTip()
    },
    handMiss(id) {
      // let high = JSON.parse(JSON.stringify(this.highlight))
      // high.forEach((item,index) => {
      //     if(item.id == id){
      //         this.highlight.splice(index, 1)
      //     }
      // })
      // let k = 0
      // for(let i=0;i<this.arr.length;i++){
      //     if(this.arr[i].length){
      //         for(let j=0;j<this.arr[i].length;j++){
      //             if(this.arr[i][j].length){
      //                 if(id == k){
      //                     this.arr[i].splice(j, 1)
      //                 }
      //                 this.advice.splice(id, 1)
      //                 k++
      //             }
      //         }
      //     }
      // }
      this.highlight.splice(id, 1)
      this.advice.splice(id, 1)
      this.miss.splice(id, 1)
      this.arrCopy.splice(id, 1)
      this.arr.splice(id, 1)
    },
    handleInputText(id, length) {
      for (let i = 0; i < this.arrIndex.length; i++) {
        if (i > id && this.arrCopy[i].length) {
          this.arrCopy[i] = [this.arrCopy[i][0] + length, this.arrCopy[i][1] + length]
        }
      }
      // console.log(publicData.arrCopy)
      this.handMiss(id)
      this.resetHigh()
    },
    // 筛选tag的背景变化
    filterResult(type) {
      switch (type) {
        case 0: {
          this.filterParams = {
            all: '',
            high: 'rgba(0, 0, 0, 0)',
            low: 'rgba(0, 0, 0, 0)',
            sensitive: 'rgba(0, 0, 0, 0)',
            symbol: 'rgba(0, 0, 0, 0)',
            custom: 'rgba(0, 0, 0, 0)'
          }
          break
        }
        case 1: {
          this.filterParams.all = 'rgba(0, 0, 0, 0)'
          if (this.filterParams.high != 'rgba(0, 0, 0, 0)') {
            this.filterParams.high = 'rgba(0, 0, 0, 0)'
          } else {
            this.filterParams.high = ''
          }
          break
        }
        case 2: {
          this.filterParams.all = 'rgba(0, 0, 0, 0)'
          if (this.filterParams.low != 'rgba(0, 0, 0, 0)') {
            this.filterParams.low = 'rgba(0, 0, 0, 0)'
          } else {
            this.filterParams.low = ''
          }
          break
        }
        case 3: {
          this.filterParams.all = 'rgba(0, 0, 0, 0)'
          if (this.filterParams.sensitive != 'rgba(0, 0, 0, 0)') {
            this.filterParams.sensitive = 'rgba(0, 0, 0, 0)'
          } else {
            this.filterParams.sensitive = ''
          }
          break
        }
        case 4: {
          this.filterParams.all = 'rgba(0, 0, 0, 0)'
          if (this.filterParams.symbol != 'rgba(0, 0, 0, 0)') {
            this.filterParams.symbol = 'rgba(0, 0, 0, 0)'
          } else {
            this.filterParams.symbol = ''
          }
          break
        }
        case 5: {
          this.filterParams.all = 'rgba(0, 0, 0, 0)'
          if (this.filterParams.custom != 'rgba(0, 0, 0, 0)') {
            this.filterParams.custom = 'rgba(0, 0, 0, 0)'
          } else {
            this.filterParams.custom = ''
          }
          break
        }
      }
      if (this.filterParams.symbol && this.filterParams.sensitive && this.filterParams.low && this.filterParams.high && this.filterParams.custom) {
        this.filterParams.all = ''
      }
      if (this.advice.length) {
        this.resetHigh()
      }
    },
    adviceType(item) {
      let text = item[2]
      if (item[0]) {
        text = ''
      } else if (item[1] != 1 && item[1] != 2 && item[1] != 8) {
        switch (item[1]) {
          case 3: {
            text = '敏感词'
            break
          }
          case 4: {
            text = '自定义敏感词'
            break
          }
          case 5: {
            text = '自定义错词'
            break
          }
          case 6: {
            text = '共享词库敏感词'
            break
          }
          case 7: {
            text = '共享词库错词'
            break
          }
          case 9: {
            text = '自定义重点词'
            break
          }
          case 10: {
            text = '共享词库重点词'
            break
          }
          default: {
            text = '其它'
            break
          }
        }
      } else {
        switch (item[2]) {
          case '4-1': {
            text = '建议删除'
            break
          }
          case '3-1': {
            text = '建议补充字词'
            break
          }
          case '7-1': {
            text = '建议调整语序'
            break
          }
          case '10-1': {
            text = '中英类型错用'
            break
          }
          case '10-2': {
            text = '成对标点'
            break
          }
          case '10-3': {
            text = '标点符号连用'
            break
          }
          case '9-2': {
            text = '日期格式'
            break
          }
          case '9-1': {
            text = '地名从属关系'
            break
          }
          default: {
            text = '其它分类'
            break
          }
        }
      }
      return text
    },
    marginStyle(item) {
      let style = ''
      for (let i = 0; i < item.length; i++) {
        if (!this.filterParamsComputer(item[i])) {
          style = 'margin-bottom: 0;'
        } else {
          style = 'margin-bottom: 12px;'
          break
        }
      }
      return style
    },
    boderStyle(item) {
      let style = ''
      // let tips = document.querySelectorAll('.check-tips')
      switch (item[1]) {
        case 1: {
          style = 'border-left: 4px solid rgba(254, 176, 59, 0.2);'
          break
        }
        case 2: {
          style = 'border-left: 4px solid rgba(230, 71, 89, 0.2);'
          break
        }
        case 3: {
          style = 'border-left: 4px solid rgba(97, 191, 232, 0.2)'
          break
        }
        // case 4: {
        //     style = 'border-left: 4px solid rgba(97, 191, 232, 0.2)'
        //     break
        // }
        // case 6: {
        //     style = 'border-left: 4px solid rgba(97, 191, 232, 0.2)'
        //     break
        // }
        // case 5: {
        //     style = 'border-left: 4px solid rgba(230, 71, 89, 0.2);'
        //     break
        // }
        // case 7: {
        //     style = 'border-left: 4px solid rgba(230, 71, 89, 0.2);'
        //     break
        // }
        case 8: {
          style = 'border-left: 4px solid rgba(170, 113, 226, .2);'
          break
        }
        default: {
          style = 'border-left: 4px solid rgba(19, 205, 82, .2);'
        }
      }
      return style
    },
    spandCard(index, index1, type) {
      let tag = document.querySelectorAll('.ijd-high-light')
      let bgc = ''
      for (let i = 0; i < tag.length; i++) {
        if (tag[i].getAttribute('id') == index) {
          bgc = tag[i]
          break
        }
      }
      let editor = document.querySelector(".ql-editor");
      // let high = document.querySelector('.highlight')
      // let h = Math.floor(editor.offsetHeight / 2);
      // console.log(bgc.offsetTop,this.wrapperInfo)
      let target = Number(bgc.style.top.replace(/px/, '')) + Number(bgc.style.height.replace(/px/, '')) - editor.offsetHeight / 2
      if (bgc) {
        animate(editor, target);
      }
      this.tipToTagHigh(tag, index)
      if (!type) {
        if (this.$refs['checkTip' + index][index1]) {
          if (this.$refs['checkTip' + index][index1].style.height == '' || this.$refs['checkTip' + index][index1].style.height == '63px') {
            this.$refs['checkTip' + index][index1].style.height = '100px'
          } else {
            this.$refs['checkTip' + index][index1].style.height = '63px'
          }
        }
      }
    },
    tipToTagHigh(tag, index) {
      let time = ''
      time = setInterval(() => {
        if (this.scrollStop == false) {
          clearInterval(time)
          for (let i = 0; i < tag.length; i++) {
            let idName = tag[i].getAttribute('id')
            let id = Number(idName)
            let name1 = tag[i].className.replace('ijd-high-light', '')
            name1 = name1.replace('-bottom', '')
            if (name1.length > 16) {
              name1 = name1.slice(0, name1.length / 2)
            }
            tag[i].className = 'ijd-high-light' + name1 + '-bottom'
            if (id == index) {
              name1 = tag[i].className + name1
              tag[i].className = name1
            }
          }
        }
      }, 100)
    },
    missCard(index, item, type = '') {
      if (this.$refs[`handleWordRef${index}`] && this.$refs[`handleWordRef${index}`][0]) {
        this.$refs[`handleWordRef${index}`][0].style.display = 'block'
      }
      let tag = document.querySelectorAll('.ijd-high-light')
      this.tipToTagHigh(tag, index)
      let styleArr = []
      let style = {
        'border-left': '',
        background: '',
        spanBackground: ''
      }
      item.forEach((item1) => {
        switch (item1[1]) {
          case 1: {
            style["border-left"] = '4px solid rgba(254, 176, 59, 1)'
            style.background = 'rgba(254, 176, 59, 0.1)'
            style.spanBackground = 'rgba(254, 176, 59, 0.3)'
            break
          }
          case 2: {
            style["border-left"] = '4px solid rgba(230, 71, 89, 1)'
            style.background = 'rgba(230, 71, 89, 0.1)'
            style.spanBackground = 'rgba(230, 71, 89, 0.3)'
            break
          }
          case 3: {
            style["border-left"] = '4px solid rgba(97, 191, 232, 1)'
            style.background = 'rgba(97, 191, 232, 0.1)'
            style.spanBackground = 'rgba(97, 191, 232, 0.3)'
            break
          }
          // case 4: {
          //     style["border-left"] = '4px solid rgba(97, 191, 232, 1)'
          //     style.background = 'rgba(97, 191, 232, 0.1)'
          //     style.spanBackground = 'rgba(97, 191, 232, 0.3)'
          //     break
          // }
          // case 6: {
          //     style["border-left"] = '4px solid rgba(97, 191, 232, 1)'
          //     style.background = 'rgba(97, 191, 232, 0.1)'
          //     style.spanBackground = 'rgba(97, 191, 232, 0.3)'
          //     break
          // }
          // case 5: {
          //     style["border-left"] = '4px solid rgba(230, 71, 89, 1)'
          //     style.background = 'rgba(230, 71, 89, 0.1)'
          //     style.spanBackground = 'rgba(230, 71, 89, 0.3)'
          //     break
          // }
          // case 7: {
          //     style["border-left"] = '4px solid rgba(230, 71, 89, 1)'
          //     style.background = 'rgba(230, 71, 89, 0.1)'
          //     style.spanBackground = 'rgba(230, 71, 89, 0.3)'
          //     break
          // }
          case 8: {
            style["border-left"] = '4px solid rgba(170, 113, 226, 1)'
            style.background = 'rgba(170, 113, 226, .1)'
            style.spanBackground = 'rgba(170, 113, 226, .3)'
            break
          }
          default: {
            style["border-left"] = '4px solid rgba(19, 205, 82, 1)'
            style.background = 'rgba(19, 205, 82, .1)'
            style.spanBackground = 'rgba(19, 205, 82, .3)'
          }
        }
        styleArr.push(JSON.parse(JSON.stringify(style)))
      })
      for (let i = 0; i < this.$refs['checkTip' + index].length; i++) {
        if (String(type)) {
          if (i == type && this.$refs['checkTip' + index][i].querySelector('.result-word')) {
            return this.$refs['checkTip' + index][i].querySelector('.result-word').style.background = styleArr[i].spanBackground
          }
        } else if (this.$refs['checkTip' + index][i]) {
          this.$refs['checkTip' + index][i].style.borderLeft = styleArr[i]["border-left"]
          this.$refs['checkTip' + index][i].style.background = styleArr[i].background
        }
      }
    },
    missCardLeave(index, item, type = '') {
      let styleArr = []
      let style = {
        'border-left': '',
        background: '',
        spanBackground: ''
      }
      item.forEach(item1 => {
        switch (item1[1]) {
          case 1: {
            style["border-left"] = '4px solid rgba(254, 176, 59, 0.2)'
            break
          }
          case 2: {
            style["border-left"] = '4px solid rgba(230, 71, 89, 0.2)'
            break
          }
          case 3: {
            style["border-left"] = '4px solid rgba(97, 191, 232, 0.2)'
            break
          }
          // case 4: {
          //     style["border-left"] = '4px solid rgba(97, 191, 232, 0.2)'
          //     break
          // }
          // case 6: {
          //     style["border-left"] = '4px solid rgba(97, 191, 232, 0.2)'
          //     break
          // }
          // case 5: {
          //     style["border-left"] = '4px solid rgba(230, 71, 89, 0.2)'
          //     break
          // }
          // case 7: {
          //     style["border-left"] = '4px solid rgba(230, 71, 89, 0.2)'
          //     break
          // }
          case 8: {
            style["border-left"] = '4px solid rgba(170, 113, 226, .2)'
            break
          }
          default: {
            style["border-left"] = '4px solid rgba(19, 205, 82, .2)'
            break
          }
        }
        styleArr.push(JSON.parse(JSON.stringify(style)))
      })

      for (let i = 0; i < this.$refs['checkTip' + index].length; i++) {
        if (String(type)) {
          if ((i == type) && this.$refs['checkTip' + index][i].querySelector('.result-word')) {
            this.$refs['checkTip' + index][i].querySelector('.result-word').style.background = ''
          }
        } else if (this.$refs['checkTip' + index][i]) {
          this.$refs['checkTip' + index][i].style.borderLeft = styleArr[i]["border-left"]
          this.$refs['checkTip' + index][i].style.background = styleArr[i].background
          if (this.$refs[`handleWordRef${index}`]) {
            this.$refs[`handleWordRef${index}`][0].style.display = 'none'
          }
        }

      }
    },
    getText(arr) {
      let text = []
      let textNum = ''
      arr.forEach((item, index) => {
        if (textNum.length < 500) {
          textNum += item
        } else {
          text.push(textNum)
          textNum = ''
        }
        if (index == arr.length - 1) {
          text.push(textNum)
        }
      })
      return text
    },
    checkText() {
      if (this.loginOrigin && !window.localStorage.getItem('encodedAuth')) {
        this.$message.error('登陆已失效，请重新登陆')
        return window.loginOut()
      }
      let ql = document.querySelector('.ql-editor')
      if (this.loginOrigin) {
        if (this.$store.state.myRole == 'free' && this.textLength > 5000) {
          return this.handleTips("文字校对最多5000字，超出可使用校对插件或前往文档校对", "去下载", 1);
        } else if (this.$store.state.myRole != 'free' && this.textLength > 10000) {
          return this.handleTips("文字校对最多1万字，超出可使用校对插件或前往文档校对", "去下载", 1);
        }
      } else {
        if (this.textLength > 500) {
          return this.$emit('editValue', 'visible', true)
        }
      }
      if (this.textLength == 0) {
        return this.$message.error('空文本')
      }
      // let arr = ql.innerText.split(/\r|\n/ig)
      // arr = this.getText(arr)
      // this.checkConfig.buttonText = '立即校对'
      // this.checkConfig.loading = false
      // arr = arr.filter(item => {
      //     if(item.length !== 0) {
      //         return item
      //     }
      // })
      // this.handleSentence(arr, api)
      this.checkInfo = {}
      this.$emit('checkConnectStatus')
      if (!this.loginOrigin) {
        return this.textCompare([ql.innerText.replace(/\r|\n/ig, '')])
      }
      this.textCompare([ql.innerText])
      // let ql = document.querySelector('.ql-editor')
      // this.wrapperInfo = ql.getBoundingClientRect()
      // let text = ql.innerText
      // // eslint-disable-next-line no-control-regex
      // text = text.replace(/\r|\n|/ig, "")
      // if(text == '') {
      //     return this.$message.error('请输入文本后再点击校对')
      // }
      // this.checkConfig.buttonText = '正在校对'
      // this.checkConfig.loading = true
      // let arr = text.split(/(?<=。)/g)
      // console.log(arr)
      // // let t = 0
      // // let time = setInterval(() => {
      // //     console.log(t++)
      // // }, 1000)
      // api.checkText({ text }, 1).then((res) => {
      //     // clearInterval(time)
      //     if(res.status == 200 && res.data.result.length) {
      //         this.handleText(res.data.result)
      //         this.checkConfig.buttonText = '立即校对'
      //         this.checkConfig.loading = false
      //     }else {
      //         this.checkConfig.buttonText = '立即校对'
      //         this.checkConfig.loading = false
      //     }
      // }).catch(() => {
      //     // clearInterval(time)
      //     this.checkConfig.buttonText = '立即校对'
      //     this.checkConfig.loading = false
      // })
    },
    // 段落比对，有bug,需要优化
    textCompare(text) {
      for (let key in this.checkObject) {
        this.checkObject[key] = []
      }
      // 需要校对的段落
      this.checki = []
      let checkLength = this.checkContent.length
      let textLength = text.length
      if (checkLength == 0) {
        for (let key in this.checkObject) {
          this.checkObject[key] = []
        }
        this.checkContent = text
        text.forEach((item, index) => {
          this.checki.push(index)
        })
      } else if (checkLength == textLength) {
        text.forEach((item, index) => {
          if (item != this.checkContent[index]) {
            this.checkContent.splice(index, 1, item)
            for (let key in this.checkObject) {
              this.checkObject[key].splice(index, 1, [])
            }
            this.checki.push(index)
          }
        })
      } else {
        if (text.length > this.checkContent.length) {
          for (let i = 0; i < text.length; i++) {
            if (this.checkContent[i]) {
              if (this.checkContent[i] != text[i]) {
                this.checkContent.splice(i, 0, text[i]);
                for (let key in this.checkObject) {
                  this.checkObject[key].splice(i, 0, [])
                }
                this.checki.push(i);
              }
            } else {
              this.checkContent.splice(i, 0, text[i]);
              for (let key in this.checkObject) {
                this.checkObject[key].splice(i, 0, [])
              }
              this.checki.push(i);
            }
          }
        } else {
          let l = this.checkContent.length - text.length;
          //  console.log('第三种',this.contents, text,l)
          for (let i = 0; i < text.length; i++) {
            for (let j = 0; j < l + 1; j++) {
              if (text.length == this.checkContent.length) {
                if (this.checkContent[i] != text[i]) {
                  this.checkObject.advice[i] = [];
                  this.checkObject.miss[i] = [];
                  this.checkObject.range[i] = [];
                  this.checkObject.arrIndex[i] = [];
                  this.checkObject.arrCopy[i] = [];
                  this.checkObject.highlight[i] = [];
                  this.checkObject.arr[i] = [];
                  this.checki.push(i);
                }
                break;
              }
              let text2 = this.checkContent[i + j]
              if (j == 0 && text2 == text[i]) {
                break;
              } else {
                if (text2 == text[i]) {
                  // text[i] = await text[i].replace(/<span.*?>|<\/span>/g, "");
                  for (let key in this.checkObject) {
                    this.checkObject[key].splice(i, j)
                  }
                  break;
                  // text = text.replace(/<p><br><\/p><p>&nbsp;&nbsp;未登录用户校对上限为1000字，登录后可校对更多文字。<\/p><p><br><\/p>/,'')
                  // await this.handleChangeCheck(this.contents[i],'',1,0,i)
                } else {
                  if (j == l) {
                    // console.log('执行',i)
                    this.checkContent.splice(i, 1, text[i]);
                    for (let key in this.checkObject) {
                      this.checkObject[key].splice(i, 1, [])
                    }
                    this.checki.push(i);
                    // console.log(i)
                  }
                }
              }
            }
          }
        }
      }
      if (text.length < this.checkContent.length) {
        this.checkContent.splice(text.length, Infinity);
        for (let key in this.checkObject) {
          this.checkObject[key].splice(text.length, Infinity)
        }
      }
      if (this.checki.length == 0) {
        this.dialogInfo = {
          visible: true,
          title: '重复校对',
          buttonText: '再次校对',
          type: 'info',
          width: '500px',
          text: '检测到当前文本已校对完成但未作修改，建议修改后再校对。'
        }
      } else {
        this.handleSentence(text)
      }
    },
    async handleSentence(text) {
      let length = 0
      if (this.checki.length) {
        this.highlight = []
        this.arrCopy = []
        this.arrIndex = []
      }
      let textLength = [0]
      for (let i = 0; i < text.length; i++) {
        let item = text[i]
        length = length + item.length
        textLength.push(length)
      }
      // let progress = 0
      for (let j = 0; j < this.checki.length; j++) {
        if (this.changeProtect == false) {
          this.checkConfig.buttonText = '正在校对'
          this.checkConfig.loading = true
          // this.checkConfig.buttonText = '正在校对' + progress + '%'
          // this.checkConfig.loading = true
          await this.chenckSentence(text[this.checki[j]], textLength[this.checki[j]], this.checki[j])
        } else if (this.changeProtect == true) {
          this.checkContent[this.checki[j]] = ''
          for (let i = this.checki[j - 1]; i < this.checkContent.length; i++) {
            this.checkContent[i] = ''
          }
          this.checkConfig.buttonText = '立即校对'
          this.checkConfig.loading = false
          // this.checkContent = text
          if (this.loginOrigin) {
            this.$store.dispatch('getHighSpeedNumber')
          }
          this.changeProtect = false
          break
          // this.checkContent = text
          // break
        }
        // progress = Math.floor((j + 1)/this.checki.length * 100)
        if ((j == this.checki.length - 1)) {
          this.checkContent = text
        }
      }
    },
    async chenckSentence(text, length, i) {
      // let t = 0
      // let time = setInterval(() => {
      //     console.log(t++)
      // }, 1000)
      let type = 3
      this.waitCheckId = true
      this.checkResultStorage = []
      if (!this.loginOrigin) {
        type = 2
        this.waitCheckId = false
      }
      if (type == 3 && !this.$store.state.sessionId) {
        this.checki = []
        this.checkContent = []
        this.checkConfig.buttonText = '立即校对'
        this.checkConfig.loading = false
        return this.$message.error('校对尚未准备就绪，请重新点击校对')
      }
      await api.checkText({ text, check_mode: this.checkMode }, type, this.$store.state.sessionId).then(async (res) => {
        // clearInterval(time)
        console.log('收到session', Date.now())
        if (type == 3) {
          this.waitCheckId = false
          if (res.status == 200 && res.data.sections.length) {
            if (this.changeProtect == false) {
              res.data.sections.forEach(item => {
                this.checkInfo[item.section_id] = item.section_pos
              })
              this.checkId.id = res.data.id
              this.checkId.time = Date.now()
              this.checkId.cancel = false
              if (this.checkResultStorage.length) {
                while (this.checkResultStorage.length > 0) {
                  const val = this.checkResultStorage.splice(0, 1)[0]
                  this.handleReuslt(val, true)
                }
              }
              // await this.handleText(res.data.result, length, i)

            }
            // this.checkConfig.buttonText = '立即校对'
            // this.checkConfig.loading = false
          }
        } else {
          if (res.status == 200 && res.data.result.length) {
            if (this.changeProtect == false) {
              await this.handleText(res.data.result, 0, i)
            }
            this.checkId.id = res.data.id
            this.checkId.time = Date.now()
            this.checkId.cancel = false
            this.checkConfig.buttonText = '立即校对'
            this.checkConfig.loading = false
            this.changeProtect = false
          }
        }
      }).catch(() => {
        // clearInterval(time)
        this.checkConfig.buttonText = '立即校对'
        this.checkConfig.loading = false
      })
    },
    // 分解校对结果, 将需要关注的不同部分进行分类处理
    async handleText(data, length, index, para = 0) {
      // 需要校正的位置
      let arr = [];
      // 句子
      let sentence = [];
      // 校正建议程度
      let advice = [];
      let miss = [];
      let pos = [];
      for (let i = 0; i < data.length; i++) {
        arr.push([]);
        pos.push(data[i].position);
        sentence.push(data[i].sentence);
        for (let j = 0; j < data[i].mistakes.length; j++) {
          if (j > 0) {
            if (data[i].mistakes[j][0][0] >= data[i].mistakes[j - 1][0][1]) {
              arr[i].push(data[i].mistakes[j][0]);
              data[i].mistakes[j][1][0].push(data[i].mistakes[j][2] || [0])
              advice.push(data[i].mistakes[j][1]);
            }
          } else {
            arr[i].push(data[i].mistakes[j][0]);
            data[i].mistakes[j][1][0].push(data[i].mistakes[j][2] || [0])
            advice.push(data[i].mistakes[j][1]);
          }
        }
      }
      // 截取原词
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].length === 1) {
          miss.push(sentence[i].slice(arr[i][0][0], arr[i][0][1]));
        } else {
          for (let j = 0; j < arr[i].length; j++) {
            miss.push(sentence[i].slice(arr[i][j][0], arr[i][j][1]));
          }
        }
      }
      // let content = ''
      // sentence.forEach(item => {
      //     content += item
      // })
      // console.log([content], content.split('\n'))
      this.checkObject.arr[index] = arr
      this.checkObject.sentence[index] = sentence
      this.checkObject.advice[index] = advice
      this.checkObject.miss[index] = miss
      this.checkObject.arrIndex[index] = []
      this.checkObject.arrCopy[index] = []
      this.checkObject.highlight[index] = []
      this.arr = this.checkObject.arr.flat(1)
      let adNum = this.checkObject.advice.flat(1)
      for (let i = 0; i < adNum.length; i++) {
        if (adNum[i][0].slice(-1)[0].id == undefined) {
          adNum[i][0].push({ id: i, para_no: para })
        } else {
          const paraId = adNum[i][0].slice(-1)[0].para_no
          adNum[i][0].splice(-1, 1, { id: i, para_no: paraId })
        }
      }
      this.advice = adNum
      this.miss = this.checkObject.miss.flat(1)
      this.sentence = this.checkObject.sentence.flat(1)
      // await this.handleEditor(length)
      let s = length
      let id = this.arrCopy.length
      for (let i = 0; i < advice.length; i++) {
        if (advice[i].length == 0) {
          advice.splice(i, 1)
        }
      }
      this.checkObject.arr[index].forEach((item, index1) => {
        if (item.length) {
          item.forEach(item1 => {
            if (item1.length) {
              this.checkObject.arrCopy[index].push([s + item1[0], s + item1[0] + item1[1] - item1[0]])
              this.handleSearch(s + item1[0], item1[1] - item1[0], id, index)
              id++
            }
          })
        }
        s += this.checkObject.sentence[index][index1].length
      })
      // this.handleHighLight()
      this.arrIndex = this.checkObject.arrIndex.flat(1)
      this.arrCopy = this.checkObject.arrCopy.flat(1)
      this.originalArr = JSON.parse(JSON.stringify(this.arrCopy))
      this.highlight = this.checkObject.highlight.flat(1)
      this.resetHigh()
      this.getRespeatTip()
    },
    handleEditor() {
      this.highlight = []
      this.arrCopy = []
      this.arrIndex = []
      let s = 0
      let id = 0
      for (let i = 0; i < this.advice.length; i++) {
        if (this.advice[i].length == 0) {
          this.advice.splice(i, 1)
        }
      }
      this.arr.forEach(async (item, index) => {
        if (item.length) {
          await item.forEach(async item1 => {
            if (item1.length) {
              this.arrCopy.push([s + item1[0], s + item1[0] + item1[1] - item1[0]])
              await this.handleSearchCopy(s + item1[0], item1[1] - item1[0], id)
              id++
            }
          })
        }
        s += this.sentence[index].length
      })
      // this.handleHighLight()
      this.handlePosition()
    },
    handlePosition() {
      this.highlightPosition = []
      let relative = {
        id: '',
        x: [],
        y: [],
      }
      this.highlight.forEach(item => {
        relative.x[0] = item.left
        relative.x[1] = item.left + item.width
        relative.y[0] = item.top
        relative.y[1] = item.top + item.height
        this.highlightPosition.push(JSON.parse(JSON.stringify(relative)))
      })
      this.$nextTick(() => {
        let tag = document.querySelectorAll('.ijd-high-light')
        this.highlight.forEach((item, index) => {
          if (tag[index]) {
            switch (this.advice[item.id][0][1]) {
              case 2: {
                tag[index].className = 'ijd-high-light light-high-bottom'
                break
              }
              case 1: {
                tag[index].className = 'ijd-high-light light-low-bottom'
                break
              }

              case 3: {
                tag[index].className = 'ijd-high-light light-sensitive-bottom'
                break
              }
              // case 4: {
              //     tag[index].className = 'ijd-high-light light-sensitive-bottom'
              //     break
              // }
              // case 5: {
              //     tag[index].className = 'ijd-high-light light-high-bottom'
              //     break
              // }
              // case 7: {
              //     tag[index].className = 'ijd-high-light light-high-bottom'
              //     break
              // }
              // case 6: {
              //     tag[index].className = 'ijd-high-light light-sensitive-bottom'
              //     break
              // }
              case 8: {
                tag[index].className = 'ijd-high-light light-symbol-bottom'
                break
              }
              default: {
                tag[index].className = 'ijd-high-light light-custom-bottom'
                break
              }
            }
          }
        })
      })
    },
    handleSearchCopy(index, l, id) {
      this.list = []
      const len = l;
      // 遍历编辑器中的所有节点
      let nodeList = this.handleNodeList();
      nodeList = nodeList.flat(Infinity);
      for (let i = 0; i < nodeList.length; i++) {
        if (nodeList[i].nodeName && nodeList[i].nodeName != 'BR') {
          if (nodeList[i].nodeName == '#text') {
            this.list.push(nodeList[i].length)
          } else if (nodeList[i].nodeName == 'TEXTAREA') {
            this.list.push(nodeList[i].value.length)
          } else {
            this.list.push(0)
          }
        } else {
          this.list.push(0)
        }

      }
      let arrIndex = this.arrNum(this.list, index, len, id)
      if (arrIndex) {
        this.arrIndex.push(JSON.parse(JSON.stringify(arrIndex)))
        arrIndex.forEach(item => {
          const textNode = nodeList[item[0]]
          // console.log(arrIndex, textNode)
          let standardRange = document.createRange();
          standardRange.setStart(textNode, 0);
          standardRange.setEnd(textNode, 0);
          let standardRangeReact = standardRange.getBoundingClientRect();
          const lineHeight = standardRangeReact.height;
          standardRange.detach(); //从文档中分离
          standardRange = null; //解除引用
          let range = document.createRange()
          range.setStart(textNode, item[1])
          range.setEnd(textNode, item[1] + item[2])
          let rangeReact = range.getBoundingClientRect()
          const height = rangeReact.height
          if (Math.floor(height) == Math.floor(lineHeight)) {
            this.highlight.push(this.calRectInfo(rangeReact, item[3]))
            range.detach()
            range = null
          } else {
            let i = 0;
            let j = 1;
            range.detach()
            range = null
            while (j <= item[2]) {
              let subRange = document.createRange();
              subRange.setStart(textNode, item[1] + i);
              subRange.setEnd(textNode, item[1] + j);
              let subRangeReact = subRange.getBoundingClientRect();
              const subHeight = subRangeReact.height
              if (Math.floor(subHeight) === Math.floor(lineHeight)) {
                if (j !== 1) this.highlight.pop();
                j++;
              } else {
                if (i == (j - 1)) {
                  this.highlight.pop();
                  i = j
                  j = i - 1
                } else {
                  i = j - 1;
                }
              }
              this.highlight.push(this.calRectInfo(subRangeReact, item[3]));
              subRange.detach()
              subRange = null
            }
          }
          // document.querySelector('.ijiaodui-copy-text')
        })
      }
    },
    // 这是根据偏移量获取文本定位的关键步骤, 也是出现bug时需要重点关注的地方
    handleSearch(index, l, id, i) {
      this.list = []
      const len = l;
      // 遍历编辑器中的所有节点
      let nodeList = this.handleNodeList();
      nodeList = nodeList.flat(Infinity);
      for (let i = 0; i < nodeList.length; i++) {
        if (nodeList[i].nodeName && nodeList[i].nodeName != 'BR') {
          if (nodeList[i].nodeName == '#text') {
            this.list.push(nodeList[i].length)
          } else if (nodeList[i].nodeName == 'TEXTAREA') {
            this.list.push(nodeList[i].value.length)
          } else {
            this.list.push(0)
          }
        } else {
          this.list.push(0)
        }

      }
      let arrIndex = this.arrNum(this.list, index, len, id)
      this.checkObject.arrIndex[i].push(JSON.parse(JSON.stringify(arrIndex)))
      arrIndex.forEach(item => {
        const textNode = nodeList[item[0]]
        // console.log(arrIndex, textNode)
        let standardRange = document.createRange();
        standardRange.setStart(textNode, 0);
        standardRange.setEnd(textNode, 0);
        let standardRangeReact = standardRange.getBoundingClientRect();
        const lineHeight = standardRangeReact.height;
        standardRange.detach(); //从文档中分离
        standardRange = null; //解除引用
        let range = document.createRange()
        range.setStart(textNode, item[1])
        range.setEnd(textNode, item[1] + item[2])
        let rangeReact = range.getBoundingClientRect()
        const height = rangeReact.height
        if (Math.floor(height) == Math.floor(lineHeight)) {
          if (!this.checkObject.highlight[i]) {
            this.checkObject.highlight[i] = []
          }
          this.checkObject.highlight[i].push(this.calRectInfo(rangeReact, item[3]))
          range.detach()
          range = null
        } else {
          let i = 0;
          let j = 1;
          range.detach()
          range = null
          while (j <= item[2]) {
            let subRange = document.createRange();
            subRange.setStart(textNode, item[1] + i);
            subRange.setEnd(textNode, item[1] + j);
            let subRangeReact = subRange.getBoundingClientRect();
            const subHeight = subRangeReact.height
            // 处理是否出现换行的情况
            if (Math.floor(subHeight) === Math.floor(lineHeight)) {
              if (j !== 1) this.highlight.pop();
              j++;
            } else {
              if (i == (j - 1)) {
                this.highlight.pop();
                i = j
                j = i - 1
              } else {
                i = j - 1;
              }
            }
            if (!this.checkObject.highlight[i]) {
              this.checkObject.highlight[i] = []
            }
            this.checkObject.highlight[i].push(this.calRectInfo(subRangeReact, item[3]));
            subRange.detach()
            subRange = null
          }
        }
        // document.querySelector('.ijiaodui-copy-text')
      })
    },
    handleNodeList() {
      let node = document.querySelector('.ql-editor').childNodes;
      if (!node.length) {
        return [node]
      }
      let nodeLength = node.length;
      let nodeList = [];

      for (let i = 0; i < nodeLength; i++) {
        nodeList.push(this.handleNodeText(node[i]));
      }
      return nodeList;
    },
    handleNodeText(node) {
      let list = [];
      if (node.childNodes.length) {
        for (let i = 0; i < node.childNodes.length; i++) {
          list.push(this.handleNodeText(node.childNodes[i]));
        }
        return list;
      } else {
        return node;
      }
    },
    arrNum(arr, index, l, id) {
      let num = 0
      let oldNum = 0
      let length = l
      let start = index
      let indexArr = []
      if (arr.length) {
        for (let i = 0; i < arr.length; i++) {
          num += arr[i]
          if (start < num) {
            // 这里判断出错误长度超出了节点末端
            if ((num - start) < length) {
              return this.handleNum(start, length, i, num, arr, oldNum, id)
            } else {
              indexArr.push([i, index - oldNum, l, id])
              return indexArr
            }
          }
          oldNum += arr[i]
        }
      } else {
        return [0, 0]
      }
    },
    handleNum(start, length, index, num, arr, oldNum, id) {
      // 这是需要高亮的位置激化，二维数组的值分别代表[要高亮的第几个节点，高亮起始位置，高亮长度]
      let indexArr = []
      let i = 0
      // 判断节点长度与错误长度之间的关系,如果高亮的长度超过了当前节点末尾，则继续计算下一个节点要高亮的长度并继续判断是否超过了计算节点的长度
      while (i < length) {
        if (i == 0) {
          indexArr.push([index, start - oldNum, num - start, id])
        } else {
          let l = length - i
          if (num - oldNum >= length - i) {
            l = length - i
          } else {
            l = num - oldNum
          }
          indexArr.push([index, 0, l, id])
        }
        // 注意：以下赋值顺序不能出错
        index++
        i += (num - start)
        start += (num - start)
        if (index - 1 > 0)
          oldNum += arr[index - 1]
        num += arr[index]
      }
      return indexArr
    },
    calRectInfo(rangeReact, id) {
      let rectInfo = {};
      rectInfo.width = rangeReact.width;
      rectInfo.height = rangeReact.height;
      rectInfo.left = rangeReact.left - this.wrapperInfo.left
      rectInfo.top = rangeReact.top - this.wrapperInfo.top + this.scrollTop
      rectInfo.id = id
      let judge = true
      if (this.advice[id] && this.advice[id].length) {
        switch (this.advice[id][0][1]) {
          case 1: {
            if (this.filterParams.all == '' || this.filterParams.low == '') {
              judge = true
            } else {
              judge = false
            }
            break
          }
          case 2: {
            if (this.filterParams.all == '' || this.filterParams.high == '') {
              judge = true
            } else {
              judge = false
            }
            break
          }
          case 3: {
            if (this.filterParams.all == '' || this.filterParams.sensitive == '') {
              judge = true
            } else {
              judge = false
            }
            break
          }
          case 8: {
            if (this.filterParams.all == '' || this.filterParams.symbol == '') {
              judge = true
            } else {
              judge = false
            }
            break
          }
          default: {
            if (this.filterParams.all == '' || this.filterParams.custom == '') {
              judge = true
            } else {
              judge = false
            }
            break
          }
        }
      }
      rectInfo.show = judge
      return rectInfo;
    },
    resetHigh() {
      this.wrapperInfo = document.querySelector('.ql-editor').getBoundingClientRect();
      this.highlight = []
      this.arrIndex = []
      if (this.arrCopy.length) {
        this.arrCopy.forEach((item, index) => {
          if (item.length) {
            this.handleSearchCopy(item[0], item[1] - item[0], index)
          } else {
            this.arrIndex.push([])
          }
        })
        //  console.log(publicData.advice)
        this.handlePosition()
      }
    },
    showNoticeTip(val) {
      const list = JSON.parse(JSON.stringify(this.notice))
      list.splice(val, 1)
      window.localStorage.setItem("notice", JSON.stringify(list));
      this.$store.commit('SetNotice', list)
      // console.log(list)
      // this.showTips = val;
      // window.localStorage.setItem("show", val);
    },
    handleCheckboxChange(checkedItems, uuid) {
      if (!this.loginOrigin) {
        // this.checkedItems=[]
        this.packInfo.visible = false
        return this.$emit('editValue', 'visible', true)
      } else {
        if (checkedItems) {
          const index = this.checkedUuids.indexOf(uuid);
          if (index == -1) {
            this.checkedUuids.push(uuid); // 将 uuid 推入数组中

          }
        } else {
          const index = this.checkedUuids.indexOf(uuid);
          if (index > -1) {
            this.checkedUuids.splice(index, 1); // 从数组中移除 uuid
          }
        }
        team.selectIndustryDic({ word_library_uuids: this.checkedUuids }).then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            this.$message.success(res.data.msg)
          }
        })
      }

    },
    showPackge() {
      this.getIndustryList()
      this.packInfo.visible = true

    },
    getIndustryList() {
      this.tabs = []
      this.checkedUuids = []
      team.getIndustryDic().then((res) => {
        const categoryChildren = res.data.data.industry_word_library_and_categories_info
        categoryChildren.forEach((category) => {
          let lists = [];
          if (category.category_children.length !== 0) {
            category.category_children.forEach((subCategory) => {
              let items = [];
              subCategory.industry_word_library_info.forEach((wordLibrary) => {
                // items.push(wordLibrary.name);
                items.push(wordLibrary);
              });
              lists.push({
                title: subCategory.name,
                items: items,
                checkedItems: []
              });
            });
            this.tabs.push({
              title: category.name,
              lists: lists
            });
          } else {
            let items = [];
            category.industry_word_library_info.forEach((wordLibrary) => {
              // items.push(wordLibrary.name);
              items.push(wordLibrary);
            });
            lists.push({
              title: category.name,
              items: items,
              checkedItems: []
            });
            this.tabs.push({
              title: category.name,
              lists: lists
            });
          }
        });
        this.tabs.forEach((tab) => {
          tab.lists.forEach((list) => {
            list.items.forEach((item) => {
              if (item.selected == 1) {
                this.checkedUuids.push(item.uuid);
              }
            });

          });
        });
      })
    },
  },
}
  </script>
  <style lang="less">
.el-dropdown-menu {
  background: #fff;
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0px 8px 12px rgba(16, 17, 19, 0.06) !important;
  overflow: hidden;
  .el-dropdown-menu__item {
    height: 38px;
    padding: 10px 20px;
    line-height: 17px;
    font-size: 14px;
    color: rgba(51, 60, 70, 1);
    border-bottom: 1px solid rgba(234, 239, 248, 0.3);
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: rgba(248, 250, 255, 1);
    color: rgba(51, 60, 70, 1);
  }
}
.el-dropdown-link {
  color: rgba(46, 112, 222, 1);
  font-size: 14px;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  display: flex;
  align-items: center;
  .dropdown-icon {
    // transform: rotate(180deg);
    vertical-align: middle;
    // transition: transform linear .3s;
  }
}
// .el-dropdown-link:active {
//     .dropdown-icon {
//             transform: rotate(0deg);
//         }
// }
.ql-editor::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 100px;
}

.ql-editor-none::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0) !important;
  animation: scroll-none ease 1s;
}

.ql-editor-display::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: rgba(51, 60, 70, 0.2);
  // background-image: -webkit-linear-gradient(
  //   45deg,
  //   rgba(255, 255, 255, 0.2) 25%,
  //   transparent 25%,
  //   transparent 50%,
  //   rgba(255, 255, 255, 0.2) 50%,
  //   rgba(255, 255, 255, 0.2) 75%,
  //   transparent 75%,
  //   transparent
  // );
}

.editor::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(51, 60, 70, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tip-container-show::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 100px;
}

// .tip-container-show::-webkit-scrollbar {
//   width: 0;
// }

.tip-container-show::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: rgba(51, 60, 70, 0.2);
}
.tip-container-none::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: rgba(51, 60, 70, 0);
}
.quill-container {
  position: relative;
  margin: 44px 0;
  margin-top: 72px;
  width: 65%;
  height: calc(100% - 116px);
  overflow: hidden;
  box-shadow: 0px 1px 3px rgba(16, 17, 19, 0.06);
  border: 0;
  border-radius: 12px;
  background: #fff;
  .toolbar-control {
    position: relative;
    margin: 35px;
    width: calc(100% - 35px);
    display: flex;
    align-items: center;
    .toolbar-menu {
      margin-right: 26px;
      cursor: pointer;
    }
    .text-length {
      position: absolute;
      right: 45px;
      top: 5px;
      color: rgba(133, 133, 133, 1);
      font-size: 14px;
      vertical-align: middle;
    }
    .el-dropdown [disabled] {
      cursor: not-allowed;
    }
    .line-height-control {
      cursor: pointer;
      // margin-left: 6px;
      font-size: 14px;
      color: rgba(46, 112, 222, 1);
      padding: 4px;
      border-radius: 4px;
      transition: all ease 0.5s;
    }
    .line-height-control:hover {
      background: rgba(46, 112, 222, 0.1);
    }
  }
  .editor-control {
    position: relative;
    height: calc(100% - 90px);
  }
  .quill-editor {
    height: 100%;
  }
  .ql-toolbar.ql-snow {
    display: none;
  }
  .ql-editor {
    padding: 0 36px 36px;
    // min-height: 715px;
    line-height: 40px;
    transition: all ease 0.3s;
    overflow-y: overlay !important;
    p {
      color: rgba(61, 61, 61, 1);
      font-size: 16px;
      font-weight: 400;
    }
  }
  .ql-container.ql-snow {
    border: 0;
  }
  .ql-editor.ql-blank::before {
    left: 36px;
    color: rgba(0, 0, 0, 0.1);
    font-style: normal;
    font-size: 16px;
    top: 0px;
  }
}
@keyframes one-in {
  from {
    padding-left: 100%;
  }
  to {
    padding-left: 0%;
  }
}
.ijd-el-popover {
  background: #ffffff !important;
  box-shadow: 0px 8px 12px rgba(16, 17, 19, 0.06) !important;
  border-radius: 8px !important;
}
</style>
  <style lang="less" scoped>
.ijd-reminder {
  display: flex;
  position: absolute;
  width: 65%;
  max-width: calc(95% + 24px);
  // min-width: 40%;
  margin-right: 24px;
  top: 24px;
  padding-top: 25px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 500;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  background-color: rgba(241, 244, 249, 1);
  color: #444;
  .reminder-text {
    margin-left: 6px;
    vertical-align: middle;
    display: inline-block;
    max-width: 90%;
    white-space: nowrap;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .close-reminder {
    margin-left: 12px;
    vertical-align: top;
    // position: absolute;
    cursor: pointer;
    // right: 18px;
    // top: 0px;
  }
}

.list-leave-active {
  transform: translate(-200px, -60px) !important;
  opacity: 0 !important;
  position: absolute !important;
  transition: all 0.8s !important;
}
// 结束
// .v-enter-active,
.list-enter-to {
  // position: absolute;
  opacity: 1;
  transform: translateX(0);
  transition: all 0.8s ease;
  // transition-delay: .8s;
}

// .v-enter-active {
//     transition-delay: 3s;
// }
// 开始
.list-enter,
.list-leave {
  opacity: 0;
  transform: translateX(230px);
}

// .v-leave-active {
//   position: absolute;
// }
.list-move {
  // transform: translateY(-12px);
  transition: all 0.8s ease;
}
.container {
  display: flex;
  align-content: space-between;
  justify-content: start;
  height: 100%;
}
.tip-container {
  margin: 20px 12px;
  width: calc(30% + 10px);
  min-width: 410px;
  position: relative;
  height: calc(100% - 40px);
  .tip-container-button {
    height: 178px;
    min-width: 400px;
    max-width: calc(100% - 10px);
    padding: 24px;
    background: #fff;
    box-shadow: 0px 1px 3px rgba(16, 17, 19, 0.06);
    border-radius: 12px;
    .tip-container-button-tag {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 8px;
    }
    .tip-container-button-tag2 {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .change-check-mode {
      display: inline-block;
      width: 56px;
      height: 44px;
      margin-left: 17px;
      vertical-align: middle;
      line-height: 14px;
      margin-right: -4px;
      padding-top: 3px;
      .mode-icon {
        display: inline-block;
        width: 100%;
        text-align: center;
        height: 20px;
      }
      .mode-opertor {
        display: inline-block;
        width: 100%;
        color: #2e70de;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        padding: 4px;
        border-radius: 2px;
        transition: background-color ease 0.5s;
      }
      .mode-opertor:hover {
        background-color: rgba(10, 86, 214, 0.1);
      }
    }
  }
  .tip-container-show {
    margin-top: 12px;
    position: relative;
    // padding-top: -12px;
    padding-bottom: 50px;
    height: calc(100% - 178px);
    overflow: auto;
    overflow: overlay;
    overflow-x: hidden;
    width: 100%;
    .empty-tip {
      position: absolute;
      // display: none;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      .tip-text {
        font-size: 14px;
        font-weight: 500;
        color: rgba(161, 168, 179, 1);
        margin-top: 7px;
      }
    }
    .respeat-tip {
      width: calc(100% - 10px);
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0px 1px 3px rgba(16, 17, 19, 0.06);
      margin-bottom: 10px;
      .respeat-tip-title {
        height: 44px;
        text-align: center;
        padding: 16px 0 11px 0;
        line-height: 16px;
        font-size: 14px;
        font-weight: 600;
        color: #444;
        border-bottom: 1px #f1f1f1 solid;
        cursor: default;
      }

      .respeat-tip-list {
        position: relative;
        width: 100%;
        padding: 12px 0;
        cursor: default;
        .respeat-tip-list-item {
          // display: flex;
          // align-items: center;
          display: grid;
          min-height: 41px;
          padding: 0 24px;
          .el-col {
            display: flex;
            align-items: center;
            height: 100%;
          }
          .respeat-number {
            display: inline-block;
            min-width: 18px;
            height: 18px;
            font-size: 12px;
            background-color: rgba(68, 68, 68, 1);
            border-radius: 4px;
            text-align: center;
            line-height: 18px;
            color: #fff;
          }
          .tip-word {
            display: inline-block;
            margin-left: 10px;
            max-width: 40%;
            white-space: pre-wrap;
            color: #333c46;
          }
          .edit-word {
            display: inline-block;
            width: 40%;
            white-space: pre-wrap;
            color: #333c46;
          }
          .word-class {
            display: inline-block;
            margin-left: 12px;
            color: rgba(133, 133, 133, 1);
            font-size: 14px;
            line-height: 26px;
            height: 24px;
          }
          .respeat-opertor {
            color: #2e70de;
            font-size: 14px;
            cursor: pointer;
            padding: 3px;
            border-radius: 4px;
            transition: background-color ease 0.3s;
            margin-left: 24px;
            white-space: nowrap;
          }
          .respeat-opertor:hover {
            background-color: rgba(10, 86, 214, 0.1);
          }
        }
        .respeat-tip-list-item:hover {
          background-color: #f2faff;
        }
      }
    }
    // .check-tips:nth-of-type(1) {
    //     margin-top: 0!important;
    // }
    .check-tips:last-of-type {
      margin-bottom: 400px;
    }
    .check-tips {
      width: calc(100% - 10px);
      margin-bottom: 12px;
      margin-right: 0;
      border-radius: 4px;
      box-shadow: 0px 1px 3px rgba(16, 17, 19, 0.06);
      overflow: hidden;
    }
    .check-tip {
      position: relative;
      padding: 20px;
      min-width: 400px;
      background: #fff;
      height: 63px;
      overflow: hidden;
      transition: all ease 0.4s;
      .word-class {
        display: inline-block;
        margin-left: 12px;
        color: rgba(133, 133, 133, 1);
        font-size: 14px;
        line-height: 26px;
        height: 24px;
      }
      .tip-word {
        display: inline-block;
        height: 24px;
        padding: 2px;
        border-radius: 2px;
        max-width: 35%;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1; /*想省略几行就写几*/
        -webkit-box-orient: vertical;
        transition: background ease 0.3s;
      }
      .result-word {
        display: inline-block;
        cursor: pointer;
        height: 24px;
        padding: 2px;
        border-radius: 2px;
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1; /*想省略几行就写几*/
        -webkit-box-orient: vertical;
        transition: background ease 0.3s;
      }
      .symbol-word {
        font-family: "楷体";
        .symbol-word-item {
          font-family: "楷体";
          display: inline-block;
          cursor: pointer;
          height: 24px;
          padding: 2px 4px;
          border-radius: 2px;
          max-width: 55%;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1; /*想省略几行就写几*/
          -webkit-box-orient: vertical;
          transition: background ease 0.3s;
        }
        .symbol-word-attribute {
          display: inline-block;
          font-size: 14px;
          margin: 0 5px;
        }
        .symbol-word-item:hover {
          background: rgba(170, 113, 226, 0.1);
        }
      }
      .delete-word {
        display: inline-block;
        cursor: pointer;
        padding: 4px;
        margin-left: 12px;
        font-size: 16px;
        border-radius: 2px;
        color: rgba(230, 71, 89, 1);
        transition: background ease 0.3s;
      }
      .delete-word:hover {
        background: rgba(230, 71, 89, 0.1);
      }
    }
    // .tip-info-content {
    //     display: flex;
    //     justify-content: space-between;
    //     align-items: center;
    // }
    .handle-word {
      display: none;
      // position: absolute;
      // right: 20px;
      // top: 0px;
      height: 24px;
      margin-right: 0px;
      color: #2e70de;
      line-height: 28px;
      .add-to-word {
        font-size: 14px;
        color: #2e70de;
        padding: 4px;
        transition: background ease 0.3s;
        line-height: 18px;
      }
      .add-to-word:hover {
        background: rgba(46, 112, 222, 0.1);
      }
      .ignore-the-word {
        display: inline-block;
        padding: 4px;
        cursor: pointer;
        font-size: 14px;
        // width: 36px;
        // height: 24px;
        margin-left: 20px;
        border-radius: 2px;
        line-height: 18px;
        transition: background ease 0.3s;
      }
      .ignore-the-word:hover {
        background: rgba(46, 112, 222, 0.1);
      }
    }
    .tip-detail {
      margin-top: 18px;
      font-size: 14px;
      color: rgba(133, 133, 133, 1);
    }
  }
}
.highlight {
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  top: 0;
  z-index: 999;
}
.ijd-high-light {
  position: absolute;
  /* border-bottom: 2px solid #ea1537; */
}
.ijd-high-light::after {
  visibility: visible !important;
  bottom: -2px !important;
  height: 2px !important;
  border-radius: 10px !important;
  content: "" !important;
  position: absolute !important;
  width: 100%;
  left: 0px !important;
  animation: ijd-high-light linear 0.8s;
}
.ijd-high-light::before {
  content: "" !important;
  position: absolute !important;
  width: 100% !important;
  left: 0px !important;
  height: 100% !important;
  top: 0px !important;
}
.light-high::before {
  background: rgba(230, 71, 89, 0.2);
  // animation: light-high linear 1.5s;
}
@keyframes light-high {
  0% {
    background: rgba(230, 71, 89, 0.2);
  }
  25% {
    background: rgba(230, 71, 89, 0);
  }
  50% {
    background: rgba(230, 71, 89, 0.6);
  }
  75% {
    background: rgba(230, 71, 89, 0);
  }
  100% {
    background: rgba(230, 71, 89, 0.2);
  }
}
.light-high-bottom::after {
  background: rgba(230, 71, 89, 1);
}
.light-low::before {
  background: rgba(254, 176, 59, 0.2);
  // animation: light-low linear 1.5s;
}
@keyframes light-low {
  0% {
    background: rgba(254, 176, 59, 0.2);
  }
  25% {
    background: rgba(254, 176, 59, 0);
  }
  50% {
    background: rgba(254, 176, 59, 0.6);
  }
  75% {
    background: rgba(254, 176, 59, 0);
  }
  100% {
    background: rgba(254, 176, 59, 0.2);
  }
}
.light-low-bottom::after {
  background: rgba(254, 176, 59, 1);
}
.light-sensitive::before {
  background: rgba(97, 191, 232, 0.2);
  // animation: light-sensitive linear 1.5s;
}
@keyframes light-sensitive {
  0% {
    background: rgba(97, 191, 232, 0.2);
  }
  25% {
    background: rgba(97, 191, 232, 0);
  }
  50% {
    background: rgba(97, 191, 232, 0.6);
  }
  75% {
    background: rgba(97, 191, 232, 0);
  }
  100% {
    background: rgba(97, 191, 232, 0.2);
  }
}
.light-sensitive-bottom::after {
  background: rgba(97, 191, 232, 1);
}
.light-symbol::before {
  background: rgba(170, 113, 226, 0.2);
  // animation: light-symbol linear 1.5s;
}
@keyframes light-symbol {
  0% {
    background: rgba(170, 113, 226, 0.2);
  }
  25% {
    background: rgba(170, 113, 226, 0);
  }
  50% {
    background: rgba(170, 113, 226, 0.6);
  }
  75% {
    background: rgba(170, 113, 226, 0);
  }
  100% {
    background: rgba(170, 113, 226, 0.2);
  }
}
.login-input-item {
  margin-bottom: 12px;
  position: relative;
  /deep/.el-form-item__label {
    padding: 0;
    font-size: 12px;
    color: rgba(133, 138, 144, 1);
    line-height: 36px;
  }
  .assist-button {
    cursor: pointer;
    position: absolute;
    right: 0;
    color: rgba(46, 112, 222, 1);
  }
  .assist-button-disabled {
    cursor: no-drop;
    position: absolute;
    right: 0;
    color: #858a90;
  }
}
.light-symbol-bottom::after {
  background: rgba(170, 113, 226, 1);
}
.light-custom::before {
  background: rgba(19, 205, 82, 0.2);
  // animation: light-symbol linear 1.5s;
}
.light-custom-bottom::after {
  background: rgba(19, 205, 82, 1);
}
@keyframes ijd-high-light {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
.display-miss {
  position: absolute;
  z-index: 9999;
  //   transition: all 0.5s;
  ul {
    list-style-type: none;
    background: #ffffff;
    box-shadow: 0px 0px 12px rgba(16, 17, 19, 0.08);
    border-radius: 8px;
    overflow: hidden;

    li {
      text-align: center;
      min-width: 146px;
      min-height: 38px;
      font-size: 14px;
      cursor: pointer;
      color: rgba(51, 60, 70, 1);
      line-height: 18px;
      padding: 10px 20px;
      border-bottom: 1px solid rgba(234, 239, 248, 1);
      background-color: #fff;

      .del-miss {
        cursor: pointer;
        margin-left: 16px;
        color: #ce532c;
      }

      .edit-miss {
        cursor: pointer;
        color: rgba(51, 60, 70, 1);
      }
    }

    li:hover {
      background-color: rgba(10, 86, 214, 0.05);
    }

    span {
      cursor: pointer;
    }

    :last-child {
      cursor: pointer;
      border: 0px;
    }
  }
}
.package {
  .nav {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #858a90;
  }

  ::v-deep .el-dialog__body {
    // padding: 17px 36px 24px 36px;
    padding: 35px 43px 24px 57px;
    // padding-right: 36px!important;
  }

  ::v-deep .el-dialog__header {
    text-align: center;
  }

  .main {
    /deep/.dic_tab {
      ::-webkit-scrollbar {
        display: none;
      }

      // ::v-deep
      .el-tabs__header {
        padding: 0;
        position: relative;
        margin: 0 0 32px;
        text-align: center;
      }

      .el-tabs__content {
        overflow: hidden;
        position: relative;
        height: 273px !important;
        overflow: auto;
      }

      .el-tabs__item {
        padding: 0;
        font-size: 14px;
        color: rgba(133, 138, 144, 1);
        font-weight: 500;
        height: 32px;
        min-width: 88px;
        line-height: 32px;
        text-align: center;
        border-radius: 8px;
      }

      .el-tabs__active-bar {
        // background-color: rgba(32, 35, 39, 1);
        height: 0px;
      }

      .el-tabs__nav-wrap::after {
        // background-color: rgba(234, 239, 248, 1);
        height: 0px;
      }

      .el-tabs__item.is-active {
        color: rgba(46, 112, 222, 1);
        background: rgba(10, 86, 214, 0.05);
        font-weight: 500;
      }

      .el-tabs__nav-prev {
        left: 0;
        bottom: -6px;
      }

      .el-tabs__nav-next {
        right: 0;
        bottom: -6px;
      }

      .content {
        .title {
          margin-bottom: 16px;
          color: #333c46;
          font-size: 14px;
          font-weight: 600;
          line-height: 18px;
        }

        .ul {
          margin-bottom: 32px;
          display: flex;
          // justify-content: space-between;
          flex-wrap: wrap;
          // li:first-child{
          //     margin-left: 0px;

          // }
          li {
            line-height: 14px;
            margin-bottom: 16px;
            // flex: 1;
            list-style: none;
            margin-right: 72px;
          }
        }
      }
    }
  }
}
</style>